import Input from "@/app/components/ui/Inputs/Input/index";
import RadioGroupComponent from "@/app/components/ui/RadioGroup";
import VariantUploadModal from "./VariantUploadModal";
import { ValidVariant } from "@/app/hooks/api_hooks/coupon/useUploadVariantsAPI";
import { ArrowUpTrayIcon, XMarkIcon } from "@heroicons/react/24/outline";
import MultiSelectDropdown from "@/app/components/ui/SelectMenus/MultiSelectDropdown";
import SearchableMultiSelectMenu from "@/app/components/ui/SelectMenus/MultiSelectMenu";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import { useCouponBomListAPICoupon } from "@/app/hooks/api_hooks/coupon/useCouponBomListAPICoupon";

import { useCouponCategoryAPI } from "@/app/hooks/api_hooks/coupon/useCouponCategoryAPI";
import { useCouponCouponCartTypeListAPI } from "@/app/hooks/api_hooks/coupon/useCouponCouponCartTypeListAPI";
import { useCouponCouponTypeListAPI } from "@/app/hooks/api_hooks/coupon/useCouponCouponTypeListAPI";
import { useCouponDetailsAPI } from "@/app/hooks/api_hooks/coupon/useCouponDetailsAPI";
import { useCouponDiscountTypeListAPI } from "@/app/hooks/api_hooks/coupon/useCouponDiscountTypeListAPI";
import { useCouponProductListAPICoupon } from "@/app/hooks/api_hooks/coupon/useCouponProductListAPICoupon";
import { useCouponSubCategoryAPICoupon } from "@/app/hooks/api_hooks/coupon/useCouponSubCategoryAPICoupon";
import { useCouponSubServiceListAPICoupon } from "@/app/hooks/api_hooks/coupon/useCouponSubServiceListAPICoupon";
import { useCouponUpdationAPI } from "@/app/hooks/api_hooks/coupon/useCouponUpdationAPI";
import { useInventoryProductCatalougeDropdownAPI } from "@/app/hooks/api_hooks/Inventory/useInventoryProductCatalougeDropdownAPI";
import { useMembershipListingAPI } from "@/app/hooks/api_hooks/Membership/useMembershipListingAPI";
import useFormValidations from "@/app/hooks/useFormValidations";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import { IMembershipState } from "@/app_redux/reducers/slices/auth/membership.slice";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";

const booleanArray = [
  {
    id: "YES",
    title: "YES",
  },
  {
    id: "NO",
    title: "NO",
  },
];

export interface ICouponServiceDiscountFromFiled {
  coupon_type?: string;
  discount_level?: string;
  cart_type?: string;
  discount_value?: string;
  discount_price_type?: string;
  cart_amount?: string;
  minimum_cart_price?: string;
  minimum_cat?: string;
  coupon_brand?: Array<string>;
  coupon_category?: Array<string>;
  coupon_sub_category?: Array<string>;
  coupon_sku?: Array<string>;
  coupon_sub_service?: Array<string>;
  coupon_bom_name?: Array<string>;
  coupon_membership?: Array<string>;
  ex_coupon_brand?: Array<string>;
  ex_coupon_category?: Array<string>;
  ex_coupon_sub_category?: Array<string>;
  ex_coupon_sku?: Array<string>;
  ex_coupon_sub_service?: Array<string>;
  ex_coupon_bom_name?: Array<string>;
  minimum_cart_value_required?: string;
  minimum_cart_value?: string;
  ex_coupon_membership?: Array<string>;

  //cart
  cart_coupon_applied?: any;
  service_discount_value?: string;
  bom_discount_value?: string;
  service_discount_price_type?: string;
  bom_discount_price_type?: string;
  service_coupon_brand?: Array<string>;
  service_coupon_category?: Array<string>;
  service_coupon_sub_category?: Array<string>;

  service_coupon_sub_service?: Array<string>;
  bom_coupon_bom_name?: Array<string>;
  bom_coupon_category?: Array<string>;
  bom_coupon_sub_category?: Array<string>;

  ex_service_coupon_category?: Array<string>;
  ex_service_coupon_sub_category?: Array<string>;
  ex_bom_coupon_category?: Array<string>;
  ex_bom_coupon_sub_category?: Array<string>;

  ex_service_coupon_sub_service?: Array<string>;
  ex_bom_coupon_bom_name?: Array<string>;
}

const CouponDiscountComponent = () => {
  const navigation = useNavigate();
  const [params, _setParams] = useSearchParams();
  const { forOnlyPercentageAndNumberRegex } = useFormValidations();
  const coupon_id = params.get("coupon_id");
  const { getRouteKey } = useRouter();
  const routeId = getRouteKey("MEMBERSHIP_SETUP", "id");
  const { routeState } = useRouteInfo(routeId);
  const { membershipList } = routeState.state as IMembershipState;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isVariantModalOpen, setIsVariantModalOpen] = useState(false);
  const [isVariantModalExclusionOpen, setIsVariantModalExclusionOpen] = useState(false);
  const [uploadedVariants, setUploadedVariants] = useState<ValidVariant[] | null>(null);
  const [preUploadSKUList, setPreUploadSKUList] = useState<string[]>([]);
  const [uploadedVariantsExclusion, setUploadedVariantsExclusion] = useState<ValidVariant[] | null>(null);
  const [preUploadSKUListExclusion, setPreUploadSKUListExclusion] = useState<string[]>([]);
  const uploadedSkuItems = useMemo(
    () => uploadedVariants?.map((v) => ({ id: v.vetic_variant_id, title: v.sku_name })) ?? null,
    [uploadedVariants],
  );
  const uploadedSkuItemsExclusion = useMemo(
    () => uploadedVariantsExclusion?.map((v) => ({ id: v.vetic_variant_id, title: v.sku_name })) ?? null,
    [uploadedVariantsExclusion],
  );

  const handleClearUpload = () => {
    setUploadedVariants(null);
    formHook.setValue("coupon_sku", preUploadSKUList);
    setPreUploadSKUList([]);
  };

  const handleClearExclusionUpload = () => {
    setUploadedVariantsExclusion(null);
    formHook.setValue("ex_coupon_sku", preUploadSKUListExclusion);
    setPreUploadSKUListExclusion([]);
  };
  const [itemLabelrequired, setItemLabelrequired] = useState(true);
  const [initialcategoryFetch, setInitialcategoryFetch] = useState<boolean>(false);
  const [initialSubcategoryFetch, setInitialSubcategoryFetch] = useState<boolean>(false);
  const [initialProductFetch, setInitialProductFetch] = useState<boolean>(false);
  const [initialSubserviceFetch, setInitialSubserviceFetch] = useState<boolean>(false);
  const [initialBomFetch, setInitialBomFetch] = useState<boolean>(false);
  const [initialBrandFetch, setInitialBrandFetch] = useState<boolean>(false);
  const [initialExclusionCategoryFetch, setInitialExclusionCategoryFetch] = useState<boolean>(false);
  const [initialExclusionSubCategoryFetch, setInitialExclusionSubCategoryFetch] = useState<boolean>(false);
  const [initialExclusionProductFetch, setInitialExclusionProductFetch] = useState<boolean>(false);
  const [initialExclusionSubserviceFetch, setInitialExclusionSubserviceFetch] = useState<boolean>(false);
  const [initialExclusionBomFetch, setInitialExclusionBomFetch] = useState<boolean>(false);
  const [initialExclusionBrandFetch, setInitialExclusionBrandFetch] = useState<boolean>(false);

  const formHook = useForm<ICouponServiceDiscountFromFiled>({
    mode: "onChange",
    defaultValues: { discount_level: "CART", discount_price_type: "FLAT" },
  });
  const { execute: fetchCouponType, discount } = useCouponDiscountTypeListAPI();
  const { searchResults: brandItems, execute: fetchBrands } = useInventoryProductCatalougeDropdownAPI("BRAND");

  const { execute: fetchCartCouponType, couponType: cartCoupnType } = useCouponCouponCartTypeListAPI();

  const { execute: fetchCategory, serviceCategory: couponCategory } = useCouponCategoryAPI();

  const { execute: fetchExclusionCategory, serviceCategory: exclusioncategory } = useCouponCategoryAPI();

  const { execute: updateCoupons } = useCouponUpdationAPI();
  const { execute: fetchCouponDetails, couponDetails } = useCouponDetailsAPI();

  const { execute: fetchExclusionSubserveList, subServiceList: subserviceExclusion } =
    useCouponSubServiceListAPICoupon();
  const { execute: fetchSubCategory, serviceSubCategory: couponSubCategory } = useCouponSubCategoryAPICoupon();
  const { execute: fetchExclusionSubCategory, serviceSubCategory: exclusionSubcategory } =
    useCouponSubCategoryAPICoupon();
  const { execute: fetchBomListAPI, bomlist } = useCouponBomListAPICoupon();
  const { execute: fetchExclusionBomListAPI, bomlist: exclusionbomlist } = useCouponBomListAPICoupon();
  const { execute: fetchCouponProductList, productList } = useCouponProductListAPICoupon();
  const { execute: fetchCouponExclusionProductList, productList: exclusionProduct } = useCouponProductListAPICoupon();
  const { execute: fetchSubserveList, subServiceList } = useCouponSubServiceListAPICoupon();

  const { execute: ServicefetchSubCategory, serviceSubCategory: ServicecouponSubCategory } =
    useCouponSubCategoryAPICoupon();
  const { execute: ServicefetchExclusionSubCategory, serviceSubCategory: ServiceexclusionSubcategory } =
    useCouponSubCategoryAPICoupon();

  const { execute: BomfetchSubCategory, serviceSubCategory: BomcouponSubCategory } = useCouponSubCategoryAPICoupon();
  const { execute: BomfetchExclusionSubCategory, serviceSubCategory: BomexclusionSubcategory } =
    useCouponSubCategoryAPICoupon();

  const { execute: fetchMemberList } = useMembershipListingAPI();

  const { execute: cartFetchCouponType, couponType } = useCouponCouponTypeListAPI();

  const couponTypeItems = useSelectMenuReducer(discount, "label", "value");
  const couponCartTypeItems = useSelectMenuReducer(cartCoupnType, "label", "value");
  const brandItemsList = useSelectMenuReducer(brandItems, "brand_name", "brand_id");
  const subServiceListItem = useSelectMenuReducer(subServiceList, "sub_service_name", "sub_service_id");
  const couponSubCategoryItem = useSelectMenuReducer(couponSubCategory, "subcategory_name", "subcategory_id");
  const couponCategoryItem = useSelectMenuReducer(couponCategory, "category_name", "id");
  const bomListItem = useSelectMenuReducer(bomlist, "bom_name", "bom_id");
  const productListItem = useSelectMenuReducer(productList, "product_name", "vetic_variant_id");
  const membershipListItem = useSelectMenuReducer(membershipList, "name", "membership_id");
  const exclusionBomListItem = useSelectMenuReducer(exclusionbomlist, "bom_name", "bom_id");
  const subExclusionServiceListItem = useSelectMenuReducer(subserviceExclusion, "sub_service_name", "sub_service_id");
  const couponExclusionSubCategoryItem = useSelectMenuReducer(
    exclusionSubcategory,
    "subcategory_name",
    "subcategory_id",
  );
  const couponExclusionCategoryItem = useSelectMenuReducer(exclusioncategory, "category_name", "id");
  const productListExclusionItem = useSelectMenuReducer(exclusionProduct, "product_name", "vetic_variant_id");
  const membershipListItemExclusion = useSelectMenuReducer(membershipList, "name", "membership_id");

  const ServicecouponSubCategoryItem = useSelectMenuReducer(
    ServicecouponSubCategory,
    "subcategory_name",
    "subcategory_id",
  );
  const BomcouponSubCategoryItem = useSelectMenuReducer(BomcouponSubCategory, "subcategory_name", "subcategory_id");

  const ServicecouponExclusionSubCategoryItem = useSelectMenuReducer(
    ServiceexclusionSubcategory,
    "subcategory_name",
    "subcategory_id",
  );
  const BomcouponExclusionSubCategoryItem = useSelectMenuReducer(
    BomexclusionSubcategory,
    "subcategory_name",
    "subcategory_id",
  );

  //

  const is_membership_coupon = couponDetails?.is_membership_coupon;
  const is_exhaustible_coupon = couponDetails?.is_exhaustible;
  const watchedSKUList = formHook.watch("coupon_sku");
  const defaultSelectedSKUList = useMemo(() => {
    return Array.isArray(watchedSKUList) && watchedSKUList.length > 0 ? formHook.getValues("coupon_sku") : [];
  }, [watchedSKUList]);
  const watchedEXSKUList = formHook.watch("ex_coupon_sku");
  const [explicitSelectAllFields, setExplicitSelectAllFields] = useState<Record<string, boolean>>({});

  const updateExplicitSelectAllField = useCallback((fieldName: string, meta?: { selectAllUsed?: boolean }) => {
    const shouldMarkAsAllInclusive = !!meta?.selectAllUsed;
    setExplicitSelectAllFields((prev) => {
      if (prev[fieldName] === shouldMarkAsAllInclusive) return prev;
      return { ...prev, [fieldName]: shouldMarkAsAllInclusive };
    });
  }, []);

  const asAllInclusiveIfExplicit = useCallback(
    (fieldName: string, values?: Array<string> | null) => {
      if (!values || values.length === 0) return values;
      return explicitSelectAllFields[fieldName] ? ["all_inclusive"] : values;
    },
    [explicitSelectAllFields],
  );

  const resolveInclusionField = useCallback(
    (fieldName: string, values?: Array<string> | null, itemList?: Array<any>) => {
      if (uploadedVariants !== null) return ["all_inclusive"];
      if (values && itemList && values.length === itemList.length) return ["all_inclusive"];
      return asAllInclusiveIfExplicit(fieldName, values);
    },
    [uploadedVariants, asAllInclusiveIfExplicit],
  );

  const resolveExclusionField = useCallback(
    (fieldName: string, values?: Array<string> | null, itemList?: Array<any>) => {
      if (uploadedVariantsExclusion !== null) return ["all_inclusive"];
      if (values && itemList && values.length === itemList.length) return ["all_inclusive"];
      return asAllInclusiveIfExplicit(fieldName, values);
    },
    [uploadedVariantsExclusion, asAllInclusiveIfExplicit],
  );

  const onSubmit = (data: any) => {
    let constructedBody: any = null;
    if (data.discount_level === "CART") {
      if (parseInt(data?.cart_amount) === 0) {
        toast.error("Discount Value 0 can't be accepted");
        return null;
      }
      if (data.minimum_cat === "YES" && parseInt(data?.minimum_cart_price) === 0) {
        toast.error("Min Cart Value 0 can't be accepted");
        return null;
      }
      constructedBody = {
        page_step: "discount_page",
        coupon_id: coupon_id,
        discount_level: data.discount_level,
        cart_discount_details: {
          discount_value: parseInt(data.cart_amount),
          discount_type: data.cart_type,
          minimum_cart_value: data.minimum_cat === "YES" ? parseFloat(data.minimum_cart_price) : null,
          cart_coupon_applied: data?.cart_coupon_applied,
          included_details: {
            product:
              data.coupon_brand && data.coupon_brand.length > 0
                ? {
                    brands: resolveInclusionField("coupon_brand", data.coupon_brand, brandItemsList),
                    category: resolveInclusionField("coupon_category", data.coupon_category, couponCategoryItem),
                    sku: asAllInclusiveIfExplicit("coupon_sku", data?.coupon_sku),
                    sub_category: resolveInclusionField(
                      "coupon_sub_category",
                      data.coupon_sub_category,
                      couponSubCategoryItem,
                    ),
                  }
                : undefined,
            service:
              data?.service_coupon_category && data?.service_coupon_category?.length > 0
                ? {
                    category: asAllInclusiveIfExplicit("service_coupon_category", data.service_coupon_category),
                    sub_category: asAllInclusiveIfExplicit(
                      "service_coupon_sub_category",
                      data.service_coupon_sub_category,
                    ),

                    sub_service: asAllInclusiveIfExplicit(
                      "service_coupon_sub_service",
                      data.service_coupon_sub_service,
                    ),
                  }
                : undefined,
            bom:
              data.bom_coupon_category && data.bom_coupon_category?.length > 0
                ? {
                    category: asAllInclusiveIfExplicit("bom_coupon_category", data.bom_coupon_category),

                    sub_category: asAllInclusiveIfExplicit("bom_coupon_sub_category", data.bom_coupon_sub_category),
                    bom: asAllInclusiveIfExplicit("bom_coupon_bom_name", data.bom_coupon_bom_name),
                  }
                : undefined,
          },
          excluded_details: {
            product:
              data.ex_coupon_brand && data.ex_coupon_brand?.length > 0
                ? {
                    ...(data.ex_coupon_brand?.length > 0 && {
                      brands: resolveExclusionField("ex_coupon_brand", data.ex_coupon_brand, brandItemsList),
                    }),

                  ...(data.ex_coupon_category?.length > 0 && {
                    category: resolveExclusionField(
                      "ex_coupon_category",
                      data.ex_coupon_category,
                      couponExclusionCategoryItem,
                    ),
                  }),
                  ...(data.ex_coupon_sku?.length > 0 && {
                    sku:
                      couponDetails?.coupon_type === "QC COUPON"
                        ? data?.ex_coupon_sku
                        : asAllInclusiveIfExplicit("ex_coupon_sku", data?.ex_coupon_sku),
                  }),
                  ...(data.ex_coupon_sub_category?.length > 0 && {
                    sub_category: resolveExclusionField(
                      "ex_coupon_sub_category",
                      data.ex_coupon_sub_category,
                      couponExclusionSubCategoryItem,
                    ),
                  }),
                }
                : undefined,
            service:
              data.ex_service_coupon_category && data.ex_service_coupon_category?.length > 0
                ? {
                    ...(data.ex_service_coupon_category?.length > 0 && {
                      category: asAllInclusiveIfExplicit("ex_service_coupon_category", data.ex_service_coupon_category),
                    }),
                    ...(data.ex_service_coupon_sub_category?.length > 0 &&
                      data.ex_service_coupon_sub_category?.length > 0 && {
                        sub_category: asAllInclusiveIfExplicit(
                          "ex_service_coupon_sub_category",
                          data.ex_service_coupon_sub_category,
                        ),
                      }),
                    ...(data.ex_service_coupon_sub_service?.length > 0 && {
                      sub_service: asAllInclusiveIfExplicit(
                        "ex_service_coupon_sub_service",
                        data.ex_service_coupon_sub_service,
                      ),
                    }),
                  }
                : undefined,
            bom:
              data.ex_bom_coupon_category && data.ex_bom_coupon_category?.length > 0
                ? {
                    ...(data.ex_bom_coupon_bom_name?.length > 0 && {
                      bom: asAllInclusiveIfExplicit("ex_bom_coupon_bom_name", data.ex_bom_coupon_bom_name),
                    }),
                    ...(data.ex_bom_coupon_category?.length > 0 && {
                      category: asAllInclusiveIfExplicit("ex_bom_coupon_category", data.ex_bom_coupon_category),
                    }),
                    ...(data.ex_bom_coupon_sub_category?.length > 0 &&
                      data.ex_bom_coupon_sub_category?.length > 0 && {
                        sub_category: asAllInclusiveIfExplicit(
                          "ex_bom_coupon_sub_category",
                          data.ex_bom_coupon_sub_category,
                        ),
                      }),
                  }
                : undefined,
          },
        },
      };
    } else if (couponDetails?.coupon_type === "PRODUCT" || couponDetails?.coupon_type === "QC COUPON") {
      if (parseInt(data?.discount_value) === 0) {
        toast.error("Discount Value 0 can't be accepted");
        return null;
      }
      constructedBody = {
        page_step: "discount_page",
        coupon_id: coupon_id,
        discount_level: data.discount_level,
        item_discount_details: {
          included_details: {
            brands: resolveInclusionField("coupon_brand", data.coupon_brand, brandItemsList),
            category: resolveInclusionField("coupon_category", data.coupon_category, couponCategoryItem),
            price: {
              discount_price_type:
                is_membership_coupon && is_exhaustible_coupon ? "PERCENTAGE" : data.discount_price_type,
              discount_value: is_membership_coupon && is_exhaustible_coupon ? 100 : parseFloat(data.discount_value),
            },
            sku:
              couponDetails?.coupon_type === "QC COUPON"
                ? data?.coupon_sku
                : asAllInclusiveIfExplicit("coupon_sku", data?.coupon_sku),
            sub_category: resolveInclusionField("coupon_sub_category", data.coupon_sub_category, couponSubCategoryItem),
          },
          excluded_details: {
            ...(data.ex_coupon_brand?.length > 0 && {
              brands: resolveExclusionField("ex_coupon_brand", data.ex_coupon_brand, brandItemsList),
            }),
            ...(data.ex_coupon_category?.length > 0 && {
              category: resolveExclusionField(
                "ex_coupon_category",
                data.ex_coupon_category,
                couponExclusionCategoryItem,
              ),
            }),
            ...(data.ex_coupon_sku?.length > 0 && {
              sku:
                couponDetails?.coupon_type === "QC COUPON"
                  ? data?.ex_coupon_sku
                  : asAllInclusiveIfExplicit("ex_coupon_sku", data?.ex_coupon_sku),
            }),
            ...(data.ex_coupon_sub_category?.length > 0 &&
              data.ex_coupon_category?.length > 0 && {
                sub_category: resolveExclusionField(
                  "ex_coupon_sub_category",
                  data.ex_coupon_sub_category,
                  couponExclusionSubCategoryItem,
                ),
              }),
          },
        },
      };
    } else if (couponDetails?.coupon_type === "SERVICE") {
      if (parseInt(data?.discount_value) === 0) {
        toast.error("Discount Value 0 can't be accepted");
        return null;
      }
      constructedBody = {
        page_step: "discount_page",
        coupon_id: coupon_id,
        discount_level: data.discount_level,
        item_discount_details: {
          included_details: {
            category: asAllInclusiveIfExplicit("coupon_category", data.coupon_category),
            price: {
              discount_price_type:
                is_membership_coupon && is_exhaustible_coupon ? "PERCENTAGE" : data.discount_price_type,
              discount_value: is_membership_coupon && is_exhaustible_coupon ? 100 : parseFloat(data.discount_value),
            },
            sub_category: asAllInclusiveIfExplicit("coupon_sub_category", data.coupon_sub_category),
            sub_service: asAllInclusiveIfExplicit("coupon_sub_service", data.coupon_sub_service),
          },
          excluded_details: {
            ...(data.ex_coupon_category?.length > 0 && {
              category: asAllInclusiveIfExplicit("ex_coupon_category", data.ex_coupon_category),
            }),
            ...(data.ex_coupon_sub_category?.length > 0 &&
              data.ex_coupon_category?.length > 0 && {
                sub_category: asAllInclusiveIfExplicit("ex_coupon_sub_category", data.ex_coupon_sub_category),
              }),
            ...(data.ex_coupon_sub_service?.length > 0 && {
              sub_service: asAllInclusiveIfExplicit("ex_coupon_sub_service", data.ex_coupon_sub_service),
            }),
          },
        },
      };
    } else if (couponDetails?.coupon_type === "DISCOUNT ON MEMBERSHIP") {
      if (parseInt(data?.discount_value) === 0) {
        toast.error("Discount Value 0 can't be accepted");
        return null;
      }
      constructedBody = {
        page_step: "discount_page",
        coupon_id: coupon_id,
        discount_level: data.discount_level,
        item_discount_details: {
          included_details: {
            price: {
              discount_price_type:
                is_membership_coupon && is_exhaustible_coupon ? "PERCENTAGE" : data.discount_price_type,
              discount_value: is_membership_coupon && is_exhaustible_coupon ? 100 : parseFloat(data.discount_value),
            },
            memberships: data.coupon_membership,
          },
          excluded_details: {
            ...(data.ex_coupon_membership?.length > 0 && {
              memberships: data.ex_coupon_membership,
            }),
          },
        },
      };
    } else {
      if (parseInt(data?.discount_value) === 0) {
        toast.error("Discount Value 0 can't be accepted");
        return null;
      }
      constructedBody = {
        page_step: "discount_page",
        coupon_id: coupon_id,
        discount_level: data.discount_level,
        item_discount_details: {
          included_details: {
            bom: asAllInclusiveIfExplicit("coupon_bom_name", data.coupon_bom_name),
            category: asAllInclusiveIfExplicit("coupon_category", data.coupon_category),
            price: {
              discount_price_type:
                is_membership_coupon && is_exhaustible_coupon ? "PERCENTAGE" : data.discount_price_type,
              discount_value: is_membership_coupon && is_exhaustible_coupon ? 100 : parseFloat(data.discount_value),
            },
            sub_category: asAllInclusiveIfExplicit("coupon_sub_category", data.coupon_sub_category),
          },
          excluded_details: {
            ...(data.ex_coupon_bom_name?.length > 0 && {
              bom: asAllInclusiveIfExplicit("ex_coupon_bom_name", data.ex_coupon_bom_name),
            }),
            ...(data.ex_coupon_category?.length > 0 && {
              category: asAllInclusiveIfExplicit("ex_coupon_category", data.ex_coupon_category),
            }),
            ...(data.ex_coupon_sub_category?.length > 0 &&
              data.ex_coupon_category?.length > 0 && {
                sub_category: asAllInclusiveIfExplicit("ex_coupon_sub_category", data.ex_coupon_sub_category),
              }),
          },
        },
      };
    }
    setIsSubmitting(true);
    updateCoupons(constructedBody).then(({ status }) => {
      setIsSubmitting(false);
      if (status) {
        navigation(`/app/coupon-service/coupon-creation?page_step=usage_details&&coupon_id=${coupon_id}`);
      }
    });
  };
  const handelBackStepper = () => {
    navigation(`/app/coupon-service/coupon-creation?page_step=details_and_schedule&&coupon_id=${coupon_id}`);
  };

  useEffect(() => {
    if (is_membership_coupon) {
      formHook.setValue("discount_level", "ITEM");
    }
  }, [is_membership_coupon]);

  useEffect(() => {
    if (couponDetails?.coupon_type === "CART LEVEL COUPON") {
      formHook.setValue("cart_coupon_applied", couponDetails?.cart_discount_details?.cart_coupon_applied);
      formHook.setValue("discount_level", "CART");
    }
    if (couponDetails?.coupon_type === "QC COUPON") {
      formHook.setValue("discount_level", "ITEM");
      formHook.setValue("discount_price_type", "PERCENTAGE");
    }
  }, [couponDetails?.coupon_type]);

  useEffect(() => {
    fetchBrands();
    fetchCouponType();
    fetchExclusionCategory();
    fetchCartCouponType();
    fetchCategory();
    fetchMemberList();
  }, []);

  useEffect(() => {
    if (coupon_id) {
      fetchCouponDetails(coupon_id);
    }
  }, [coupon_id]);

  useEffect(() => {
    const discount_level = couponDetails?.discount_level;
    const discount_details = couponDetails;
    const item_discount_details = discount_details?.item_discount_details;
    formHook.setValue("coupon_type", couponDetails?.coupon_type);
    const resolvedLevel = couponDetails?.coupon_type === "CART LEVEL COUPON" ? "CART" : discount_level;
    if (resolvedLevel) {
      formHook.setValue("discount_level", resolvedLevel);
      if (resolvedLevel === "CART") {
        formHook.setValue("cart_amount", discount_details?.cart_discount_details?.discount_value?.toString());
        formHook.setValue("cart_type", discount_details?.cart_discount_details?.discount_type);
        formHook.setValue("minimum_cat", discount_details?.cart_discount_details?.minimum_cart_value ? "YES" : "NO");
        formHook.setValue(
          "minimum_cart_price",
          discount_details?.cart_discount_details?.minimum_cart_value?.toString() || null,
        );
      } else {
        if (item_discount_details) {
          const included_details = item_discount_details?.included_details;
          formHook.setValue(
            "discount_price_type",
            included_details?.price?.discount_price_type && included_details?.price?.discount_price_type,
          );
          formHook.setValue("discount_value", included_details?.price?.discount_value?.toString());
          formHook.setValue("coupon_membership", included_details?.memberships);
          const excluded_details = item_discount_details?.excluded_details;
          formHook.setValue("ex_coupon_membership", excluded_details?.memberships);
        }
      }
    } else if (
      couponDetails?.coupon_type === "DISCOUNT ON MEMBERSHIP" ||
      couponDetails?.coupon_type === "BOM" ||
      couponDetails?.coupon_type === "SERVICE"
    ) {
      formHook.setValue("discount_level", "ITEM");
    }
  }, [couponDetails]);

  useEffect(() => {
    const isCart = formHook.getValues("discount_level");
    if (isCart === "CART") {
      setItemLabelrequired(false);
    } else {
      setItemLabelrequired(true);
    }
  }, [formHook.watch("discount_level")]);

  // cart level cart_discount_details

  // INCLUDE

  //all category
  useEffect(() => {
    const cart_discount_details = couponDetails?.cart_discount_details;
    if (cart_discount_details && !initialcategoryFetch && couponCategoryItem?.length > 0) {
      const included_details = cart_discount_details?.included_details;
      formHook.setValue(
        "coupon_category",
        included_details?.product?.category?.length > 0 && included_details?.product?.category[0] === "all_inclusive"
          ? couponCategoryItem?.map((id) => id.id)
          : included_details?.product?.category,
      );
      formHook.setValue(
        "service_coupon_category",
        included_details?.service?.category?.length > 0 && included_details?.service?.category[0] === "all_inclusive"
          ? couponCategoryItem?.map((id) => id.id)
          : included_details?.service?.category,
      );
      formHook.setValue(
        "bom_coupon_category",
        included_details?.bom?.category?.length > 0 && included_details?.bom?.category[0] === "all_inclusive"
          ? couponCategoryItem?.map((id) => id.id)
          : included_details?.bom?.category,
      );
      setInitialcategoryFetch(true);
    }
  }, [couponDetails, couponCategoryItem?.length > 0, initialcategoryFetch]);

  //Brand
  useEffect(() => {
    const item_discount_details = couponDetails?.cart_discount_details;
    if (item_discount_details && !initialBrandFetch && brandItemsList?.length > 0) {
      const included_details = item_discount_details?.included_details;
      formHook.setValue(
        "coupon_brand",
        included_details?.product?.brands?.length > 0 && included_details?.product?.brands[0] === "all_inclusive"
          ? brandItemsList?.map((i) => i.id)
          : included_details?.product?.brands,
      );
      setInitialBrandFetch(true);
    }
  }, [couponDetails, brandItemsList?.length > 0, initialBrandFetch]);

  //Sku

  useEffect(() => {
    const item_discount_details = couponDetails?.cart_discount_details;
    if (item_discount_details && !initialProductFetch && productListItem?.length > 0) {
      const included_details = item_discount_details?.included_details;
      formHook.setValue(
        "coupon_sku",
        included_details?.product?.sku?.length > 0 && included_details?.product?.sku[0] === "all_inclusive"
          ? productListItem?.map((i) => i.id)
          : included_details?.product?.sku,
      );
      setInitialProductFetch(true);
    }
  }, [couponDetails, productListItem?.length > 0, initialProductFetch]);

  //sub category for sku
  useEffect(() => {
    const cart_discount_details = couponDetails?.cart_discount_details;
    if (cart_discount_details && !initialSubcategoryFetch && couponSubCategoryItem?.length > 0) {
      const included_details = cart_discount_details?.included_details;
      formHook.setValue(
        "coupon_sub_category",
        included_details?.product?.sub_category?.length > 0 &&
          included_details?.product?.sub_category[0] === "all_inclusive"
          ? couponSubCategoryItem?.map((id) => id.id)
          : included_details?.product?.category,
      );

      setInitialSubcategoryFetch(true);
    }
  }, [couponDetails, couponSubCategoryItem?.length > 0, initialSubcategoryFetch]);

  //sub category for service
  const [ServiceinitialSubcategoryFetch, setServiceinitialSubcategoryFetch] = useState(false);

  useEffect(() => {
    const cart_discount_details = couponDetails?.cart_discount_details;
    if (cart_discount_details && !ServiceinitialSubcategoryFetch && ServicecouponSubCategoryItem?.length > 0) {
      const included_details = cart_discount_details?.included_details;
      formHook.setValue(
        "service_coupon_sub_category",
        included_details?.service?.sub_category?.length > 0 &&
          included_details?.service?.sub_category[0] === "all_inclusive"
          ? ServicecouponSubCategoryItem?.map((id) => id.id)
          : included_details?.service?.sub_category,
      );
      setServiceinitialSubcategoryFetch(true);
    }
  }, [couponDetails, ServicecouponSubCategoryItem?.length > 0, ServiceinitialSubcategoryFetch]);

  //sub category for bom
  const [BominitialSubcategoryFetch, setBominitialSubcategoryFetch] = useState(false);

  useEffect(() => {
    const cart_discount_details = couponDetails?.cart_discount_details;
    if (cart_discount_details && !BominitialSubcategoryFetch && BomcouponSubCategoryItem?.length > 0) {
      const included_details = cart_discount_details?.included_details;
      formHook.setValue(
        "bom_coupon_sub_category",
        included_details?.bom?.sub_category?.length > 0 && included_details?.bom?.sub_category[0] === "all_inclusive"
          ? BomcouponSubCategoryItem?.map((id) => id.id)
          : included_details?.bom?.sub_category,
      );
      setBominitialSubcategoryFetch(true);
    }
  }, [couponDetails, BomcouponSubCategoryItem?.length > 0, BominitialSubcategoryFetch]);

  //service for include

  useEffect(() => {
    const item_discount_details = couponDetails?.cart_discount_details;
    if (item_discount_details && !initialSubserviceFetch && subServiceListItem?.length > 0) {
      const included_details = item_discount_details?.included_details;
      formHook.setValue(
        "service_coupon_sub_service",
        included_details?.service?.sub_service?.length > 0 &&
          included_details?.service?.sub_service[0] === "all_inclusive"
          ? subServiceListItem?.map((id) => id.id)
          : included_details?.service?.sub_service,
      );
      setInitialSubserviceFetch(true);
    }
  }, [couponDetails, subServiceListItem?.length > 0, initialSubserviceFetch]);

  //bom
  useEffect(() => {
    const item_discount_details = couponDetails?.cart_discount_details;
    if (item_discount_details && !initialBomFetch && bomListItem?.length > 0) {
      const included_details = item_discount_details?.included_details;
      formHook.setValue(
        "bom_coupon_bom_name",
        included_details?.bom?.bom?.length > 0 && included_details?.bom?.bom[0] === "all_inclusive"
          ? bomListItem?.map((i) => i.id)
          : included_details?.bom?.bom,
      );
      setInitialBomFetch(true);
    }
  }, [couponDetails, bomListItem?.length > 0, initialBomFetch]);

  //Exclude

  //all exclusion category
  useEffect(() => {
    const item_discount_details = couponDetails?.cart_discount_details;
    if (item_discount_details && !initialExclusionCategoryFetch && couponExclusionCategoryItem?.length > 0) {
      const excluded_details = item_discount_details?.excluded_details;
      formHook.setValue(
        "ex_coupon_category",
        excluded_details?.product?.category?.length > 0 && excluded_details?.product?.category[0] === "all_inclusive"
          ? couponExclusionCategoryItem?.map((i) => i.id)
          : excluded_details?.product?.category,
      );
      formHook.setValue(
        "ex_service_coupon_category",
        excluded_details?.service?.category?.length > 0 && excluded_details?.service?.category[0] === "all_inclusive"
          ? couponExclusionCategoryItem?.map((i) => i.id)
          : excluded_details?.service?.category,
      );
      formHook.setValue(
        "ex_bom_coupon_category",
        excluded_details?.bom?.category?.length > 0 && excluded_details?.bom?.category[0] === "all_inclusive"
          ? couponExclusionCategoryItem?.map((i) => i.id)
          : excluded_details?.bom?.category,
      );
      setInitialExclusionCategoryFetch(true);
    }
  }, [couponDetails, couponExclusionCategoryItem?.length > 0, initialExclusionCategoryFetch]);

  //Sku

  useEffect(() => {
    const item_discount_details = couponDetails?.cart_discount_details;
    if (item_discount_details && !initialExclusionProductFetch && productListExclusionItem?.length > 0) {
      const excluded_details = item_discount_details?.excluded_details;
      formHook.setValue(
        "ex_coupon_sku",
        excluded_details?.product?.sku?.length > 0 && excluded_details?.product?.sku[0] === "all_inclusive"
          ? productListExclusionItem?.map((i) => i.id)
          : excluded_details?.product?.sku,
      );
      setInitialExclusionProductFetch(true);
    }
  }, [couponDetails, productListExclusionItem?.length > 0, initialExclusionProductFetch]);

  // Brand for ex

  useEffect(() => {
    const item_discount_details = couponDetails?.cart_discount_details;
    if (item_discount_details && !initialExclusionBomFetch && brandItemsList?.length > 0) {
      const excluded_details = item_discount_details?.excluded_details;
      formHook.setValue(
        "ex_coupon_brand",
        excluded_details?.product?.brands?.length > 0 && excluded_details?.product?.brands[0] === "all_inclusive"
          ? brandItemsList?.map((i) => i.id)
          : excluded_details?.product?.brands,
      );
      setInitialExclusionBrandFetch(true);
    }
  }, [couponDetails, brandItemsList?.length > 0, initialExclusionBrandFetch]);

  // sub category for sku
  useEffect(() => {
    const item_discount_details = couponDetails?.cart_discount_details;
    if (item_discount_details && !initialExclusionSubCategoryFetch && couponExclusionSubCategoryItem?.length > 0) {
      const excluded_details = item_discount_details?.excluded_details;
      formHook.setValue(
        "ex_coupon_sub_category",
        excluded_details?.product?.sub_category?.length > 0 &&
          excluded_details?.product?.sub_category[0] === "all_inclusive"
          ? couponExclusionSubCategoryItem?.map((i) => i.id)
          : excluded_details?.product?.sub_category,
      );

      setInitialExclusionSubCategoryFetch(true);
    }
  }, [couponDetails, couponExclusionSubCategoryItem?.length > 0, initialExclusionSubCategoryFetch]);

  //exclude sub category for service
  const [ServiceinitialExclusionSubCategoryFetch, setServiceinitialExclusionSubCategoryFetch] = useState(false);

  useEffect(() => {
    const item_discount_details = couponDetails?.cart_discount_details;
    if (
      item_discount_details &&
      !ServiceinitialExclusionSubCategoryFetch &&
      ServicecouponExclusionSubCategoryItem?.length > 0
    ) {
      const excluded_details = item_discount_details?.excluded_details;

      formHook.setValue(
        "ex_service_coupon_sub_category",
        excluded_details?.service?.sub_category?.length > 0 &&
          excluded_details?.service?.sub_category[0] === "all_inclusive"
          ? ServicecouponExclusionSubCategoryItem?.map((i) => i.id)
          : excluded_details?.service?.sub_category,
      );
      setServiceinitialExclusionSubCategoryFetch(true);
    }
  }, [couponDetails, ServicecouponExclusionSubCategoryItem?.length > 0, ServiceinitialExclusionSubCategoryFetch]);

  //exclude sub category for bom

  const [BominitialExclusionSubCategoryFetch, setBominitialExclusionSubCategoryFetch] = useState(false);

  useEffect(() => {
    const item_discount_details = couponDetails?.cart_discount_details;
    if (
      item_discount_details &&
      !BominitialExclusionSubCategoryFetch &&
      BomcouponExclusionSubCategoryItem?.length > 0
    ) {
      const excluded_details = item_discount_details?.excluded_details;

      formHook.setValue(
        "ex_bom_coupon_sub_category",
        excluded_details?.bom?.sub_category?.length > 0 && excluded_details?.bom?.sub_category[0] === "all_inclusive"
          ? BomcouponExclusionSubCategoryItem?.map((i) => i.id)
          : excluded_details?.bom?.sub_category,
      );
      setBominitialExclusionSubCategoryFetch(true);
    }
  }, [couponDetails, BomcouponExclusionSubCategoryItem?.length > 0, BominitialExclusionSubCategoryFetch]);

  //service for excl
  useEffect(() => {
    const item_discount_details = couponDetails?.cart_discount_details;
    if (item_discount_details && !initialExclusionSubserviceFetch && subExclusionServiceListItem?.length > 0) {
      const excluded_details = item_discount_details?.excluded_details;
      formHook.setValue(
        "ex_service_coupon_sub_service",
        excluded_details?.service?.sub_service?.length > 0 &&
          excluded_details?.service?.sub_service[0] === "all_inclusive"
          ? subExclusionServiceListItem?.map((i) => i.id)
          : excluded_details?.service?.sub_service,
      );
      setInitialExclusionSubserviceFetch(true);
    }
  }, [couponDetails, subExclusionServiceListItem?.length > 0, initialExclusionSubserviceFetch]);

  //Bom for exlc

  useEffect(() => {
    const item_discount_details = couponDetails?.cart_discount_details;
    if (item_discount_details && !initialExclusionBomFetch && exclusionBomListItem?.length > 0) {
      const excluded_details = item_discount_details?.excluded_details;
      formHook.setValue(
        "ex_bom_coupon_bom_name",
        excluded_details?.bom?.bom?.length > 0 && excluded_details?.bom?.bom[0] === "all_inclusive"
          ? exclusionBomListItem?.map((i) => i.id)
          : excluded_details?.bom?.bom,
      );
      setInitialExclusionBomFetch(true);
    }
  }, [couponDetails, exclusionBomListItem?.length > 0, initialExclusionBomFetch]);

  //END Iteration

  useEffect(() => {
    const item_discount_details = couponDetails?.item_discount_details;
    if (item_discount_details && !initialcategoryFetch && couponCategoryItem?.length > 0) {
      const included_details = item_discount_details?.included_details;
      formHook.setValue(
        "coupon_category",
        included_details?.category?.length > 0 && included_details?.category[0] === "all_inclusive"
          ? couponCategoryItem?.map((id) => id.id)
          : included_details?.category,
      );
      setInitialcategoryFetch(true);
    }
  }, [couponDetails, couponCategoryItem?.length > 0, initialcategoryFetch]);

  useEffect(() => {
    const item_discount_details = couponDetails?.item_discount_details;
    if (item_discount_details && !initialSubcategoryFetch && couponSubCategory?.length > 0) {
      const included_details = item_discount_details?.included_details;
      formHook.setValue(
        "coupon_sub_category",
        included_details?.sub_category && included_details?.sub_category[0] === "all_inclusive"
          ? couponSubCategoryItem?.map((i) => i.id)
          : included_details?.sub_category,
      );
      setInitialSubcategoryFetch(true);
    }
  }, [couponDetails, couponSubCategory?.length > 0, initialSubcategoryFetch]);

  useEffect(() => {
    const item_discount_details = couponDetails?.item_discount_details;
    if (item_discount_details && !initialProductFetch && productListItem?.length > 0) {
      const included_details = item_discount_details?.included_details;
      formHook.setValue(
        "coupon_sku",
        included_details?.sku?.length > 0 && included_details?.sku[0] === "all_inclusive"
          ? productListItem?.map((i) => i.id)
          : included_details?.sku,
      );
      setInitialProductFetch(true);
    }
  }, [couponDetails, productListItem?.length > 0, initialProductFetch]);

  useEffect(() => {
    const item_discount_details = couponDetails?.item_discount_details;
    if (item_discount_details && !initialSubserviceFetch && subServiceListItem?.length > 0) {
      const included_details = item_discount_details?.included_details;
      formHook.setValue(
        "coupon_sub_service",
        included_details?.sub_service?.length > 0 && included_details?.sub_service[0] === "all_inclusive"
          ? subServiceListItem?.map((id) => id.id)
          : Array.isArray(included_details?.sub_service)
            ? included_details?.sub_service
            : [],
      );
      setInitialSubserviceFetch(true);
    }
  }, [couponDetails, subServiceListItem?.length > 0, initialSubserviceFetch]);

  useEffect(() => {
    const item_discount_details = couponDetails?.item_discount_details;
    if (item_discount_details && !initialBomFetch && bomListItem?.length > 0) {
      const included_details = item_discount_details?.included_details;
      formHook.setValue(
        "coupon_bom_name",
        included_details?.bom?.length > 0 && included_details?.bom[0] === "all_inclusive"
          ? bomListItem?.map((i) => i.id)
          : included_details?.bom,
      );
      setInitialBomFetch(true);
    }
  }, [couponDetails, bomListItem?.length > 0, initialBomFetch]);

  useEffect(() => {
    const item_discount_details = couponDetails?.item_discount_details;
    if (item_discount_details && !initialBrandFetch && brandItemsList?.length > 0) {
      const included_details = item_discount_details?.included_details;
      formHook.setValue(
        "coupon_brand",
        included_details?.brands?.length > 0 && included_details?.brands[0] === "all_inclusive"
          ? brandItemsList?.map((i) => i.id)
          : included_details?.brands,
      );
      setInitialBrandFetch(true);
    }
  }, [couponDetails, brandItemsList?.length > 0, initialBrandFetch]);

  useEffect(() => {
    const item_discount_details = couponDetails?.item_discount_details;
    if (item_discount_details && !initialExclusionCategoryFetch && couponExclusionCategoryItem?.length > 0) {
      const excluded_details = item_discount_details?.excluded_details;
      formHook.setValue(
        "ex_coupon_category",
        excluded_details?.category?.length > 0 && excluded_details?.category[0] === "all_inclusive"
          ? couponExclusionCategoryItem?.map((i) => i.id)
          : excluded_details?.category,
      );
      setInitialExclusionCategoryFetch(true);
    }
  }, [couponDetails, couponExclusionCategoryItem?.length > 0, initialExclusionCategoryFetch]);

  useEffect(() => {
    const item_discount_details = couponDetails?.item_discount_details;
    if (item_discount_details && !initialExclusionSubCategoryFetch && couponExclusionSubCategoryItem?.length > 0) {
      const excluded_details = item_discount_details?.excluded_details;
      formHook.setValue(
        "ex_coupon_sub_category",
        excluded_details?.sub_category?.length > 0 && excluded_details?.sub_category[0] === "all_inclusive"
          ? couponExclusionSubCategoryItem?.map((i) => i.id)
          : excluded_details?.sub_category,
      );
      setInitialExclusionSubCategoryFetch(true);
    }
  }, [couponDetails, couponExclusionSubCategoryItem?.length > 0, initialExclusionSubCategoryFetch]);

  useEffect(() => {
    const item_discount_details = couponDetails?.item_discount_details;
    if (item_discount_details && !initialExclusionProductFetch && productListExclusionItem?.length > 0) {
      const excluded_details = item_discount_details?.excluded_details;
      formHook.setValue(
        "ex_coupon_sku",
        excluded_details?.sku?.length > 0 && excluded_details?.sku[0] === "all_inclusive"
          ? productListExclusionItem?.map((i) => i.id)
          : excluded_details?.sku,
      );
      setInitialExclusionProductFetch(true);
    }
  }, [couponDetails, productListExclusionItem?.length > 0, initialExclusionProductFetch]);

  useEffect(() => {
    const item_discount_details = couponDetails?.item_discount_details;
    if (item_discount_details && !initialExclusionSubserviceFetch && subExclusionServiceListItem?.length > 0) {
      const excluded_details = item_discount_details?.excluded_details;
      formHook.setValue(
        "ex_coupon_sub_service",
        excluded_details?.sub_service?.length > 0 && excluded_details?.sub_service[0] === "all_inclusive"
          ? subExclusionServiceListItem?.map((i) => i.id)
          : excluded_details?.sub_service,
      );
      setInitialExclusionSubserviceFetch(true);
    }
  }, [couponDetails, subExclusionServiceListItem?.length > 0, initialExclusionSubserviceFetch]);

  useEffect(() => {
    const item_discount_details = couponDetails?.item_discount_details;
    if (item_discount_details && !initialExclusionBomFetch && exclusionBomListItem?.length > 0) {
      const excluded_details = item_discount_details?.excluded_details;
      formHook.setValue(
        "ex_coupon_bom_name",
        excluded_details?.bom?.length > 0 && excluded_details?.bom[0] === "all_inclusive"
          ? exclusionBomListItem?.map((i) => i.id)
          : excluded_details?.bom,
      );
      setInitialExclusionBomFetch(true);
    }
  }, [couponDetails, exclusionBomListItem?.length > 0, initialExclusionBomFetch]);

  useEffect(() => {
    const item_discount_details = couponDetails?.item_discount_details;
    if (item_discount_details && !initialExclusionBomFetch && brandItemsList?.length > 0) {
      const excluded_details = item_discount_details?.excluded_details;
      formHook.setValue(
        "ex_coupon_brand",
        excluded_details?.brands?.length > 0 && excluded_details?.brands[0] === "all_inclusive"
          ? brandItemsList?.map((i) => i.id)
          : excluded_details?.brands,
      );
      setInitialExclusionBrandFetch(true);
    }
  }, [couponDetails, brandItemsList?.length > 0, initialExclusionBrandFetch]);

  useEffect(() => {
    const selectedCategory = formHook.watch("coupon_category");
    if (selectedCategory) {
      fetchSubCategory(
        selectedCategory?.length === couponCategoryItem?.length ? (["all_inclusive"] as any) : selectedCategory,
      );
    }
  }, [formHook.watch("coupon_category")]);

  useEffect(() => {
    const selectedCategory = formHook.watch("ex_coupon_category");
    if (selectedCategory) {
      fetchExclusionSubCategory(
        selectedCategory?.length === couponExclusionCategoryItem?.length
          ? (["all_inclusive"] as any)
          : selectedCategory,
      ).then((response) => {
        if (response.status) {
          formHook.setValue(
            "ex_coupon_sub_category",
            couponDetails?.item_discount_details?.excluded_details?.sub_category?.length > 0
              ? couponDetails?.item_discount_details?.excluded_details?.sub_category
              : [],
          );
        }
      });
    }
  }, [formHook.watch("ex_coupon_category")]);

  useEffect(() => {
    const selectedSubCategory = formHook.watch("coupon_sub_category");
    const couponcategory = formHook.watch("coupon_category");
    const selectedBrand = formHook.watch("coupon_brand");
    const coupon_type = formHook.watch("coupon_type");
    if (selectedSubCategory) {
      if (coupon_type === "PRODUCT" || coupon_type === "QC COUPON") {
        fetchCouponProductList(
          selectedSubCategory?.length > 0 && selectedSubCategory?.length === couponSubCategory?.length
            ? (["all_inclusive"] as any)
            : selectedSubCategory,
          formHook.getValues("coupon_category")?.length > 0 &&
            formHook.getValues("coupon_category")?.length === couponCategoryItem?.length
            ? (["all_inclusive"] as any)
            : formHook.getValues("coupon_category"),
          selectedBrand?.length > 0 && selectedBrand?.length === brandItemsList?.length
            ? (["all_inclusive"] as any)
            : selectedBrand,
        ).then((response) => {
          if (response.status) {
            //
          }
        });
      }
      if (coupon_type === "BOM") {
        fetchBomListAPI(
          selectedSubCategory?.length === couponSubCategory?.length ? (["all_inclusive"] as any) : selectedSubCategory,
          couponcategory?.length === couponCategoryItem?.length ? (["all_inclusive"] as any) : couponcategory,
        ).then((response) => {
          if (response.status) {
            formHook.setValue(
              "coupon_bom_name",
              couponDetails?.item_discount_details?.included_details?.bom?.length > 0
                ? couponDetails?.item_discount_details?.included_details?.bom
                : [],
            );
          }
        });
      }
      if (coupon_type === "SERVICE") {
        fetchSubserveList(
          selectedSubCategory?.length === couponSubCategoryItem?.length
            ? (["all_inclusive"] as any)
            : selectedSubCategory,
          couponcategory?.length === couponCategoryItem?.length ? (["all_inclusive"] as any) : couponcategory,
        ).then(({ status }) => {
          if (status) {
            //
          }
        });
      }
    }
  }, [formHook.watch("coupon_sub_category"), formHook.watch("coupon_brand")]);

  useEffect(() => {
    const selectedSubCategory = formHook.watch("ex_coupon_sub_category");
    const selectedExclusioncouponcategory = formHook.watch("ex_coupon_category");
    const selectedBrand = formHook.watch("ex_coupon_brand");
    const coupon_type = formHook.watch("coupon_type");
    if (selectedSubCategory) {
      if (coupon_type === "PRODUCT" || coupon_type === "QC COUPON") {
        fetchCouponExclusionProductList(
          selectedSubCategory?.length === couponExclusionSubCategoryItem?.length
            ? (["all_inclusive"] as any)
            : selectedSubCategory,
          formHook.getValues("ex_coupon_category")?.length === couponExclusionCategoryItem?.length
            ? (["all_inclusive"] as any)
            : formHook.getValues("ex_coupon_category"),
          selectedBrand?.length === brandItems?.length ? (["all_inclusive"] as any) : selectedBrand,
        ).then((response) => {
          if (response.status) {
            //
          }
        });
      }
      if (coupon_type === "BOM") {
        fetchExclusionBomListAPI(
          selectedSubCategory?.length === couponExclusionSubCategoryItem?.length
            ? (["all_inclusive"] as any)
            : selectedSubCategory,
          formHook.getValues("ex_coupon_category")?.length === couponExclusionCategoryItem?.length
            ? (["all_inclusive"] as any)
            : formHook.getValues("ex_coupon_category"),
        ).then((response) => {
          if (response.status) {
            //
          }
        });
      }
      if (coupon_type === "SERVICE") {
        fetchExclusionSubserveList(
          selectedSubCategory?.length === couponExclusionSubCategoryItem?.length
            ? (["all_inclusive"] as any)
            : selectedSubCategory,
          selectedExclusioncouponcategory?.length === couponExclusionCategoryItem?.length
            ? (["all_inclusive"] as any)
            : selectedExclusioncouponcategory,
        ).then(({ status }) => {
          if (status) {
            //
          }
        });
      }
    }
  }, [formHook.watch("ex_coupon_sub_category"), formHook.watch("ex_coupon_brand")]);

  const handleSelectItemSKUList = useCallback(
    (items, meta?: { selectAllUsed?: boolean }) => {
      updateExplicitSelectAllField("coupon_sku", meta);
      const currentItems = formHook.getValues("coupon_sku") || [];
      if (JSON.stringify(currentItems) !== JSON.stringify(items)) {
        formHook.setValue("coupon_sku", items?.length > 0 ? items : []);
      }
    },
    [formHook, updateExplicitSelectAllField],
  );

  const defaultSelectedEXSKUList = useMemo(() => {
    return Array.isArray(watchedEXSKUList) && watchedEXSKUList.length > 0 ? formHook.getValues("ex_coupon_sku") : [];
  }, [watchedEXSKUList]);

  const handleSelectItemEXSKUList = useCallback(
    (items, meta?: { selectAllUsed?: boolean }) => {
      updateExplicitSelectAllField("ex_coupon_sku", meta);
      const currentItems = formHook.getValues("ex_coupon_sku") || [];
      if (JSON.stringify(currentItems) !== JSON.stringify(items)) {
        formHook.setValue("ex_coupon_sku", items?.length > 0 ? items : []);
      }
    },
    [formHook, updateExplicitSelectAllField],
  );

  const defaultSelectedBrandList = useMemo(() => {
    const brands = formHook.watch("coupon_brand");
    return Array.isArray(brands) && brands.length > 0 ? formHook.getValues("coupon_brand") : [];
  }, [formHook.watch("coupon_brand")]);

  // MultiSelectDropdown reports its selection on mount and when defaults load, so only clear
  // dependent fields on a real change — otherwise edit mode wipes the saved SKUs.
  const handleSelectItemBrandList = useCallback(
    (items, meta?: { selectAllUsed?: boolean }) => {
      updateExplicitSelectAllField("coupon_brand", meta);
      const currentItems = formHook.getValues("coupon_brand") || [];
      if (JSON.stringify(currentItems) !== JSON.stringify(items)) {
        formHook.setValue("coupon_brand", items);
        formHook.setValue("coupon_sku", []);
        updateExplicitSelectAllField("coupon_sku", { selectAllUsed: false });
      }
    },
    [formHook, updateExplicitSelectAllField],
  );

  const defaultSelectedCategoryList = useMemo(() => {
    const categories = formHook.watch("coupon_category");
    return Array.isArray(categories) && categories.length > 0 ? formHook.getValues("coupon_category") : [];
  }, [formHook.watch("coupon_category")]);

  const handleSelectItemCategoryList = useCallback(
    (items, meta?: { selectAllUsed?: boolean }) => {
      updateExplicitSelectAllField("coupon_category", meta);
      const currentItems = formHook.getValues("coupon_category") || [];
      if (JSON.stringify(currentItems) !== JSON.stringify(items)) {
        formHook.setValue("coupon_category", items);
        if (formHook.getValues("coupon_type") === "SERVICE") {
          formHook.setValue("coupon_sub_category", null);
          formHook.setValue("coupon_sub_service", null);
          updateExplicitSelectAllField("coupon_sub_category", { selectAllUsed: false });
          updateExplicitSelectAllField("coupon_sub_service", { selectAllUsed: false });
        }
      }
    },
    [formHook, updateExplicitSelectAllField],
  );

  const defaultSelectedSubCategoryList = useMemo(() => {
    const subCategories = formHook.watch("coupon_sub_category");
    return Array.isArray(subCategories) && subCategories.length > 0 ? formHook.getValues("coupon_sub_category") : [];
  }, [formHook.watch("coupon_sub_category")]);

  // Remount the sub category dropdown when categories change so it drops ticks that the
  // category handler has already cleared from the form.
  const subCategoryDropdownKey = JSON.stringify(formHook.watch("coupon_category") ?? []);

  const handleSelectItemSubCategoryList = useCallback(
    (items, meta?: { selectAllUsed?: boolean }) => {
      updateExplicitSelectAllField("coupon_sub_category", meta);
      const currentItems = formHook.getValues("coupon_sub_category") || [];
      if (JSON.stringify(currentItems) !== JSON.stringify(items)) {
        formHook.setValue("coupon_sub_category", items);
        const couponType = formHook.getValues("coupon_type");
        if (couponType === "SERVICE") {
          formHook.setValue("coupon_sub_service", null);
          updateExplicitSelectAllField("coupon_sub_service", { selectAllUsed: false });
        }
        if (couponType === "BOM") {
          formHook.setValue("coupon_bom_name", null);
          updateExplicitSelectAllField("coupon_bom_name", { selectAllUsed: false });
        }
      }
    },
    [formHook, updateExplicitSelectAllField],
  );

  const defaultSelectedSubServiceList = useMemo(() => {
    const excludePersona = formHook.watch("coupon_sub_service");
    return Array.isArray(excludePersona) && excludePersona.length > 0 ? formHook.getValues("coupon_sub_service") : [];
  }, [formHook.watch("coupon_sub_service")]);

  const handleSelectItemSubServiceList = useCallback(
    (items, meta?: { selectAllUsed?: boolean }) => {
      updateExplicitSelectAllField("coupon_sub_service", meta);
      formHook.setValue("coupon_sub_service", items);
    },
    [formHook, updateExplicitSelectAllField],
  );

  const defaultSelectedEXBrandList = useMemo(() => {
    const brands = formHook.watch("ex_coupon_brand");
    return Array.isArray(brands) && brands.length > 0 ? formHook.getValues("ex_coupon_brand") : [];
  }, [formHook.watch("ex_coupon_brand")]);

  const handleSelectItemEXBrandList = useCallback(
    (items, meta?: { selectAllUsed?: boolean }) => {
      updateExplicitSelectAllField("ex_coupon_brand", meta);
      const currentItems = formHook.getValues("ex_coupon_brand") || [];
      if (JSON.stringify(currentItems) !== JSON.stringify(items)) {
        formHook.setValue("ex_coupon_brand", items);
        fetchCouponExclusionProductList(
          "",
          "",
          items?.length === brandItemsList?.length ? (["all_inclusive"] as any) : items,
        );
      }
    },
    [formHook, updateExplicitSelectAllField, fetchCouponExclusionProductList, brandItemsList?.length],
  );

  const defaultSelectedEXCategoryList = useMemo(() => {
    const categories = formHook.watch("ex_coupon_category");
    return Array.isArray(categories) && categories.length > 0 ? formHook.getValues("ex_coupon_category") : [];
  }, [formHook.watch("ex_coupon_category")]);

  const handleSelectItemEXCategoryList = useCallback(
    (items, meta?: { selectAllUsed?: boolean }) => {
      updateExplicitSelectAllField("ex_coupon_category", meta);
      const currentItems = formHook.getValues("ex_coupon_category") || [];
      if (JSON.stringify(currentItems) !== JSON.stringify(items)) {
        formHook.setValue("ex_coupon_category", items);
      }
    },
    [formHook, updateExplicitSelectAllField],
  );

  const defaultSelectedEXSubCategoryList = useMemo(() => {
    const subCategories = formHook.watch("ex_coupon_sub_category");
    return Array.isArray(subCategories) && subCategories.length > 0
      ? formHook.getValues("ex_coupon_sub_category")
      : [];
  }, [formHook.watch("ex_coupon_sub_category")]);

  // The ex_coupon_category effect rewrites ex_coupon_sub_category once the new list arrives, so
  // remount on both to keep the dropdown's ticks in line with the form.
  const exSubCategoryDropdownKey = `${JSON.stringify(formHook.watch("ex_coupon_category") ?? [])}|${couponExclusionSubCategoryItem
    .map((i) => i.id)
    .join(",")}`;

  const handleSelectItemEXSubCategoryList = useCallback(
    (items, meta?: { selectAllUsed?: boolean }) => {
      updateExplicitSelectAllField("ex_coupon_sub_category", meta);
      const currentItems = formHook.getValues("ex_coupon_sub_category") || [];
      if (JSON.stringify(currentItems) !== JSON.stringify(items)) {
        formHook.setValue("ex_coupon_sub_category", items);
      }
    },
    [formHook, updateExplicitSelectAllField],
  );

  const defaultSelectedEXBomList = useMemo(() => {
    const boms = formHook.watch("ex_coupon_bom_name");
    return Array.isArray(boms) && boms.length > 0 ? formHook.getValues("ex_coupon_bom_name") : [];
  }, [formHook.watch("ex_coupon_bom_name")]);

  const handleSelectItemEXBomList = useCallback(
    (items, meta?: { selectAllUsed?: boolean }) => {
      updateExplicitSelectAllField("ex_coupon_bom_name", meta);
      const currentItems = formHook.getValues("ex_coupon_bom_name") || [];
      if (JSON.stringify(currentItems) !== JSON.stringify(items)) {
        formHook.setValue("ex_coupon_bom_name", items);
      }
    },
    [formHook, updateExplicitSelectAllField],
  );

  const defaultSelectedEXSubServiceList = useMemo(() => {
    const excludePersona = formHook.watch("ex_coupon_sub_service");
    return Array.isArray(excludePersona) && excludePersona.length > 0
      ? formHook.getValues("ex_coupon_sub_service")
      : [];
  }, [formHook.watch("ex_coupon_sub_service")]);

  const handleSelectItemEXSubServiceList = useCallback(
    (items, meta?: { selectAllUsed?: boolean }) => {
      updateExplicitSelectAllField("ex_coupon_sub_service", meta);
      formHook.setValue("ex_coupon_sub_service", items);
    },
    [formHook, updateExplicitSelectAllField],
  );

  //cart level
  const CartcouponTypeItems = useSelectMenuReducer(couponType, "value", "id");

  const defaultSelectedSubServiceListService = useMemo(() => {
    const excludePersona = formHook.watch("service_coupon_sub_service");
    return Array.isArray(excludePersona) && excludePersona.length > 0
      ? formHook.getValues("service_coupon_sub_service")
      : [];
  }, [formHook.watch("service_coupon_sub_service")]);

  const handleSelectItemSubServiceListService = useCallback(
    (items, meta?: { selectAllUsed?: boolean }) => {
      updateExplicitSelectAllField("service_coupon_sub_service", meta);
      formHook.setValue("service_coupon_sub_service", items);
    },
    [formHook, updateExplicitSelectAllField],
  );

  const defaultSelectedEXSubServiceListService = useMemo(() => {
    const excludePersona = formHook.watch("ex_service_coupon_sub_service");
    return Array.isArray(excludePersona) && excludePersona.length > 0
      ? formHook.getValues("ex_service_coupon_sub_service")
      : [];
  }, [formHook.watch("ex_service_coupon_sub_service")]);

  const handleSelectItemEXSubServiceListService = useCallback(
    (items, meta?: { selectAllUsed?: boolean }) => {
      updateExplicitSelectAllField("ex_service_coupon_sub_service", meta);
      formHook.setValue("ex_service_coupon_sub_service", items);
    },
    [formHook, updateExplicitSelectAllField],
  );

  //Service

  useEffect(() => {
    const selectedCategory = formHook.watch("service_coupon_category");
    if (selectedCategory) {
      ServicefetchSubCategory(
        selectedCategory?.length === couponCategoryItem?.length ? (["all_inclusive"] as any) : selectedCategory,
      );
    }
  }, [formHook.watch("service_coupon_category")]);

  useEffect(() => {
    const selectedCategory = formHook.watch("bom_coupon_category");
    if (selectedCategory) {
      BomfetchSubCategory(
        selectedCategory?.length === BomcouponSubCategoryItem?.length ? (["all_inclusive"] as any) : selectedCategory,
      );
    }
  }, [formHook.watch("bom_coupon_category")]);

  useEffect(() => {
    const selectedCategory = formHook.watch("ex_bom_coupon_category");
    if (selectedCategory) {
      BomfetchExclusionSubCategory(
        selectedCategory?.length === BomcouponExclusionSubCategoryItem?.length
          ? (["all_inclusive"] as any)
          : selectedCategory,
      );
    }
  }, [formHook.watch("ex_bom_coupon_category")]);

  useEffect(() => {
    const selectedSubCategory = formHook.watch("service_coupon_sub_category");
    const couponcategory = formHook.watch("service_coupon_category");
    if (selectedSubCategory) {
      fetchSubserveList(
        selectedSubCategory?.length === couponSubCategoryItem?.length
          ? (["all_inclusive"] as any)
          : selectedSubCategory,
        couponcategory?.length === couponCategoryItem?.length ? (["all_inclusive"] as any) : couponcategory,
      ).then(({ status }) => {
        if (status) {
          //
        }
      });
    }
  }, [formHook.watch("service_coupon_sub_category")]);

  useEffect(() => {
    const selectedCategory = formHook.watch("ex_service_coupon_category");
    if (selectedCategory) {
      ServicefetchExclusionSubCategory(
        selectedCategory?.length === couponExclusionCategoryItem?.length
          ? (["all_inclusive"] as any)
          : selectedCategory,
      ).then((response) => {
        if (response.status) {
          formHook.setValue(
            "ex_service_coupon_sub_category",
            couponDetails?.item_discount_details?.excluded_details?.sub_category?.length > 0
              ? couponDetails?.item_discount_details?.excluded_details?.sub_category
              : [],
          );
        }
      });
    }
  }, [formHook.watch("ex_service_coupon_category")]);

  useEffect(() => {
    const selectedSubCategory = formHook.watch("ex_service_coupon_sub_category");
    const selectedExclusioncouponcategory = formHook.watch("ex_service_coupon_category");

    if (selectedSubCategory) {
      fetchExclusionSubserveList(
        selectedSubCategory?.length === ServicecouponExclusionSubCategoryItem?.length
          ? (["all_inclusive"] as any)
          : selectedSubCategory,
        selectedExclusioncouponcategory?.length === couponExclusionCategoryItem?.length
          ? (["all_inclusive"] as any)
          : selectedExclusioncouponcategory,
      ).then(({ status }) => {
        if (status) {
          //
        }
      });
    }
  }, [formHook.watch("ex_service_coupon_sub_category")]);
  ///BOM
  useEffect(() => {
    const selectedSubCategory = formHook.watch("bom_coupon_sub_category");
    const couponcategory = formHook.watch("bom_coupon_category");
    if (selectedSubCategory) {
      fetchBomListAPI(
        selectedSubCategory?.length === couponSubCategory?.length ? (["all_inclusive"] as any) : selectedSubCategory,
        couponcategory?.length === couponCategoryItem?.length ? (["all_inclusive"] as any) : couponcategory,
      ).then((response) => {
        if (response.status) {
          formHook.setValue(
            "bom_coupon_bom_name",
            couponDetails?.item_discount_details?.included_details?.bom?.length > 0
              ? couponDetails?.item_discount_details?.included_details?.bom
              : [],
          );
        }
      });
    }
  }, [formHook.watch("bom_coupon_sub_category")]);

  useEffect(() => {
    const selectedSubCategory = formHook.watch("ex_bom_coupon_sub_category");
    if (selectedSubCategory) {
      fetchExclusionBomListAPI(
        selectedSubCategory?.length === couponExclusionSubCategoryItem?.length
          ? (["all_inclusive"] as any)
          : selectedSubCategory,
        formHook.getValues("ex_bom_coupon_category")?.length === couponExclusionCategoryItem?.length
          ? (["all_inclusive"] as any)
          : formHook.getValues("ex_bom_coupon_category"),
      ).then((response) => {
        if (response.status) {
          //
        }
      });
    }
  }, [formHook.watch("ex_bom_coupon_sub_category")]);

  //Product

  useEffect(() => {
    const selectedSubCategory = formHook.watch("ex_coupon_sub_category");
    const selectedBrand = formHook.watch("ex_coupon_brand");
    if (selectedSubCategory && couponDetails?.coupon_type === "CART LEVEL COUPON") {
      fetchCouponExclusionProductList(
        selectedSubCategory?.length === couponExclusionSubCategoryItem?.length
          ? (["all_inclusive"] as any)
          : selectedSubCategory,
        formHook.getValues("ex_coupon_category")?.length === couponExclusionCategoryItem?.length
          ? (["all_inclusive"] as any)
          : formHook.getValues("ex_coupon_category"),
        selectedBrand?.length === brandItems?.length ? (["all_inclusive"] as any) : selectedBrand,
      ).then((response) => {
        if (response.status) {
          //
        }
      });
    }
  }, [formHook.watch("ex_coupon_sub_category"), formHook.watch("ex_coupon_brand")]);

  useEffect(() => {
    const selectedSubCategory = formHook.watch("coupon_sub_category");
    const selectedBrand = formHook.watch("coupon_brand");
    if (selectedSubCategory && couponDetails?.coupon_type === "CART LEVEL COUPON") {
      fetchCouponProductList(
        selectedSubCategory?.length > 0 && selectedSubCategory?.length === couponSubCategory?.length
          ? (["all_inclusive"] as any)
          : selectedSubCategory,
        formHook.getValues("coupon_category")?.length > 0 &&
          formHook.getValues("coupon_category")?.length === couponCategoryItem?.length
          ? (["all_inclusive"] as any)
          : formHook.getValues("coupon_category"),
        selectedBrand?.length > 0 && selectedBrand?.length === brandItemsList?.length
          ? (["all_inclusive"] as any)
          : selectedBrand,
      ).then((response) => {
        if (response.status) {
          //
        }
      });
    }
  }, [formHook.watch("coupon_sub_category"), formHook.watch("coupon_brand")]);

  useEffect(() => {
    cartFetchCouponType();
  }, []);

  useEffect(() => {
    if (couponDetails?.coupon_type === "QC COUPON" && uploadedVariants !== null) {
      formHook.unregister("coupon_sku", { keepValue: true });
    }
  }, [uploadedVariants, couponDetails?.coupon_type]);

  return (
    <div className="p-4 bg-white">
      <div className="p-3 py-3">
        <form
          className="w-full mt-3"
          onSubmit={formHook.handleSubmit(onSubmit, (errors) => console.log("Form validation errors:", errors))}
        >
          <div className="mt-4 flex flex-col gap-6 w-full">
            <div className="flex flex-col sm:flex-row sm:items-center py-2 gap-1.5 sm:gap-0">
              <div className="w-full sm:w-2/12">
                <p className="text-sm font-semibold text-gray-700">
                  Discount Type <span className="text-red-400">*</span>
                </p>
              </div>
              <div className="w-full sm:w-5/12 lg:w-4/12">
                <div className="gap-3">
                  {couponDetails?.coupon_type !== "CART LEVEL COUPON" &&
                  (is_membership_coupon ||
                    couponDetails?.coupon_type === "DISCOUNT ON MEMBERSHIP" ||
                    couponDetails?.coupon_type === "BOM" ||
                    couponDetails?.coupon_type === "SERVICE" ||
                    couponDetails?.coupon_type === "QC COUPON") ? (
                    <p className="text-sm font-semibold text-gray-800">Item Level</p>
                  ) : (
                    <RadioGroupComponent
                      alignment="horizontal"
                      errorMessages={[]}
                      fieldError={formHook.formState.errors.discount_level}
                      register={formHook.register("discount_level")}
                      groupOptions={[
                        { id: "CART", title: "Cart Level" },
                        ...(couponDetails?.coupon_type === "CART LEVEL COUPON"
                          ? []
                          : [{ id: "ITEM", title: "Item Level" }]),
                      ]}
                      defaultSelectedId={formHook.watch("discount_level")}
                      onRadioChange={(optionId: string) => {
                        formHook.setValue("discount_level", optionId as any);
                      }}
                      radioOptionClassName="text-sm"
                    />
                  )}
                </div>
              </div>
            </div>
            <hr />
            {formHook.watch("discount_level") === "CART" ? (
              <div>
                <h2 className="text-sm font-bold text-gray-800 tracking-wide uppercase mb-4">Cart Level Discount</h2>
                <div className="flex items-center py-5">
                  <div className="w-2/12">
                    <p>
                      Discount Value <span className="text-red-400">*</span>
                    </p>
                  </div>
                  <div className="w-3/12 grid grid-cols-3 gap-4">
                    <div className="col-span-2">
                      <SearchableSelectMenu
                        errorMessages={[{ message: "", type: "required" }]}
                        onSelectItem={(item) => {
                          if (item) {
                            formHook.setValue("cart_type", item.id);
                          }
                        }}
                        fieldError={formHook.formState.errors.cart_type}
                        register={formHook.register("cart_type", { required: true })}
                        selectItems={couponCartTypeItems}
                        placeholder="Select"
                        showTooltips={true}
                        showTypedErrors={true}
                        showDropdownIcon={true}
                        defaultSelected={couponCartTypeItems?.filter((oc) => oc.id === formHook.watch("cart_type"))[0]}
                        listBoxClassName="w-36"
                        className="text-gray-800 col-span-1"
                        containerClassName="w-full"
                      />
                    </div>
                    <div className="col-span-1">
                      <Input
                        className="text-xs col-span-1"
                        placeholder="Enter Value"
                        register={formHook.register("cart_amount", {
                          required: true,
                          max: 9999,
                          ...(forOnlyPercentageAndNumberRegex.validations as any),
                        })}
                        fieldError={formHook.formState.errors.cart_amount}
                        errorMessages={[
                          { message: "", type: "required" },
                          forOnlyPercentageAndNumberRegex.errors,
                          { message: "Maximum value allowed is 9999", type: "max" },
                        ]}
                      />{" "}
                    </div>
                  </div>
                </div>
                <div className="flex items-center py-5">
                  <div className="w-2/12">
                    <p>
                      Add Min Cart Value <span className="text-red-400">*</span>
                    </p>
                  </div>
                  <div className="w-3/12 grid grid-cols-2 gap-4">
                    <SearchableSelectMenu
                      errorMessages={[{ message: "", type: "required" }]}
                      onSelectItem={(item) => {
                        if (item) {
                          formHook.setValue("minimum_cat", item.id);
                        }
                      }}
                      fieldError={formHook.formState.errors.minimum_cat}
                      register={formHook.register("minimum_cat", { required: true })}
                      selectItems={booleanArray}
                      placeholder="Select"
                      showTooltips={true}
                      showTypedErrors={true}
                      showDropdownIcon={true}
                      defaultSelected={booleanArray?.filter((oc) => oc.id === formHook.watch("minimum_cat"))[0]}
                      listBoxClassName="w-36"
                      className="text-gray-800"
                      containerClassName="w-full"
                    />
                    {formHook.watch("minimum_cat") === "YES" && (
                      <Input
                        className="text-xs"
                        placeholder="Enter Value"
                        register={formHook.register("minimum_cart_price", {
                          required: true,
                          ...(forOnlyPercentageAndNumberRegex.validations as any),
                        })}
                        fieldError={formHook.formState.errors.minimum_cart_price}
                        errorMessages={[{ message: "", type: "required" }, forOnlyPercentageAndNumberRegex.errors]}
                      />
                    )}
                  </div>
                </div>

                <div className="flex items-center mt-4 border-t pt-4">
                  <div className="w-2/12">
                    <p>
                      Item Type <span className="text-red-400">*</span>
                    </p>
                  </div>
                  <div className="w-2/12">
                    <SearchableMultiSelectMenu
                      onSelectItem={(items) => {
                        const brandId = items.map((i) => i.title);
                        formHook.setValue("cart_coupon_applied", brandId);
                      }}
                      errorMessages={[{ message: "", type: "required" }]}
                      fieldError={formHook.formState.errors.cart_coupon_applied}
                      register={formHook.register("cart_coupon_applied", {
                        required: itemLabelrequired,
                      })}
                      withSelectAll
                      withDropDownSearch
                      showTooltips={true}
                      showTypedErrors={false}
                      placeholder="Select Type"
                      defaultSelected={CartcouponTypeItems.filter(
                        (c) =>
                          formHook.watch("cart_coupon_applied")?.includes(c.title) &&
                          !(couponDetails?.coupon_type === "CART LEVEL COUPON" && c.title === "QC COUPON"),
                      )}
                      selectItems={CartcouponTypeItems.filter(
                        (item) =>
                          item.title !== "DISCOUNT ON MEMBERSHIP" &&
                          item.title !== "CART LEVEL COUPON" &&
                          !(couponDetails?.coupon_type === "CART LEVEL COUPON" && item.title === "QC COUPON"),
                      )}
                    />
                  </div>
                </div>
                <div>
                  <div>
                    <div className="-mx-4  sm:-mx-6 lg:-mx-8 py-4">
                      <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                        <div className="ring-opacity-5 sm:rounded-lg">
                          {formHook.watch("cart_coupon_applied")?.includes("PRODUCT") && (
                            <>
                              <h3 className="text-xs font-bold text-gray-700 uppercase tracking-wider mb-2">
                                PRODUCT LEVEL :
                              </h3>
                              <div className="pl-10">
                                <h4 className="text-xs font-bold text-gray-800 uppercase tracking-wide mb-3">
                                  Inclusion
                                </h4>

                                <div className="border border-gray-150 rounded-xl shadow-sm bg-white mb-6">
                                  <table className="min-w-full divide-y divide-gray-100">
                                    <thead>
                                      <tr>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 rounded-tl-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider pl-4"
                                        >
                                          Brand
                                        </th>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                        >
                                          Category
                                        </th>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                        >
                                          Sub Category
                                        </th>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 rounded-tr-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                        >
                                          SKU
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-100">
                                      <tr>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <SearchableMultiSelectMenu
                                            onSelectItem={(items, meta) => {
                                              const brandId = items.map((i) => i.id);
                                              formHook.setValue("coupon_brand", brandId);
                                              formHook.setValue("coupon_sku", []);
                                              updateExplicitSelectAllField("coupon_brand", meta);
                                              updateExplicitSelectAllField("coupon_sku", { selectAllUsed: false });
                                            }}
                                            errorMessages={[{ message: "", type: "required" }]}
                                            fieldError={formHook.formState.errors.coupon_brand}
                                            register={formHook.register("coupon_brand", {
                                              required: itemLabelrequired,
                                            })}
                                            withSelectAll
                                            withDropDownSearch
                                            showTooltips={true}
                                            showTypedErrors={false}
                                            placeholder="Select Brands"
                                            defaultSelected={brandItemsList.filter((c) =>
                                              formHook.watch("coupon_brand")?.includes(c.id),
                                            )}
                                            selectItems={brandItemsList}
                                          />
                                        </td>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <SearchableMultiSelectMenu
                                            onSelectItem={(items, meta) => {
                                              const categoryId = items.map((i) => i.id);
                                              formHook.setValue("coupon_category", categoryId);
                                              updateExplicitSelectAllField("coupon_category", meta);
                                            }}
                                            withDropDownSearch
                                            errorMessages={[{ message: "", type: "required" }]}
                                            fieldError={formHook.formState.errors.coupon_category}
                                            register={formHook.register("coupon_category", {
                                              required: itemLabelrequired,
                                            })}
                                            withSelectAll
                                            showTooltips={true}
                                            showTypedErrors={false}
                                            placeholder="Select Category"
                                            defaultSelected={couponCategoryItem.filter((c) =>
                                              formHook.watch("coupon_category")?.includes(c.id),
                                            )}
                                            selectItems={couponCategoryItem}
                                          />
                                        </td>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <SearchableMultiSelectMenu
                                            onSelectItem={(items, meta) => {
                                              const sub_categoryId = items.map((i) => i.id);
                                              formHook.setValue("coupon_sub_category", sub_categoryId);
                                              updateExplicitSelectAllField("coupon_sub_category", meta);
                                            }}
                                            withDropDownSearch
                                            errorMessages={[{ message: "", type: "required" }]}
                                            fieldError={formHook.formState.errors.coupon_sub_category}
                                            register={formHook.register("coupon_sub_category", {
                                              required: itemLabelrequired,
                                            })}
                                            withSelectAll
                                            showTooltips={true}
                                            showTypedErrors={false}
                                            placeholder="Select Sub Category"
                                            defaultSelected={couponSubCategoryItem.filter((c) =>
                                              formHook.watch("coupon_sub_category")?.includes(c.id),
                                            )}
                                            selectItems={couponSubCategoryItem}
                                          />
                                        </td>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <MultiSelectDropdown
                                            data={productListItem}
                                            selectedKey="id"
                                            onSelectItem={handleSelectItemSKUList}
                                            defaultSelected={defaultSelectedSKUList}
                                            required={itemLabelrequired}
                                            register={formHook.register}
                                            name="coupon_sku"
                                            error={formHook.formState.errors.coupon_sku as any}
                                            containerClassName="w-full"
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <h4 className="text-xs font-bold text-gray-800 uppercase tracking-wide mb-3">
                                  Exclusion
                                </h4>
                                <div className="border border-gray-150 rounded-xl shadow-sm bg-white mb-6">
                                  <table className="min-w-full divide-y divide-gray-100">
                                    <thead>
                                      <tr>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 rounded-tl-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider pl-4"
                                        >
                                          Brand
                                        </th>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                        >
                                          Category
                                        </th>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                        >
                                          Sub Category
                                        </th>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 rounded-tr-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                        >
                                          SKU
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-100">
                                      <tr>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <SearchableMultiSelectMenu
                                            onSelectItem={(items, meta) => {
                                              const cityId = items.map((i) => i.id);
                                              formHook.setValue("ex_coupon_brand", cityId);
                                              updateExplicitSelectAllField("ex_coupon_brand", meta);
                                              fetchCouponExclusionProductList(
                                                "",
                                                "",
                                                cityId?.length === brandItemsList?.length
                                                  ? (["all_inclusive"] as any)
                                                  : cityId,
                                              );
                                            }}
                                            errorMessages={[{ message: "", type: "required" }]}
                                            fieldError={formHook.formState.errors.ex_coupon_brand}
                                            register={formHook.register("ex_coupon_brand", {
                                              required: false,
                                            })}
                                            withSelectAll
                                            withDropDownSearch
                                            showTooltips={true}
                                            showTypedErrors={false}
                                            containerClassName=""
                                            placeholder="Select Brands"
                                            defaultSelected={brandItemsList.filter((c) =>
                                              formHook.watch("ex_coupon_brand")?.includes(c.id),
                                            )}
                                            selectItems={brandItemsList}
                                          />
                                        </td>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <SearchableMultiSelectMenu
                                            onSelectItem={(items, meta) => {
                                              const cityId = items.map((i) => i.id);
                                              formHook.setValue("ex_coupon_category", cityId);
                                              updateExplicitSelectAllField("ex_coupon_category", meta);
                                            }}
                                            errorMessages={[{ message: "", type: "required" }]}
                                            fieldError={formHook.formState.errors.ex_coupon_category}
                                            register={formHook.register("ex_coupon_category", {
                                              required: false,
                                            })}
                                            withSelectAll
                                            withDropDownSearch
                                            showTooltips={true}
                                            showTypedErrors={false}
                                            containerClassName=""
                                            placeholder="Select Category"
                                            defaultSelected={couponExclusionCategoryItem.filter((c) =>
                                              formHook.watch("ex_coupon_category")?.includes(c.id),
                                            )}
                                            selectItems={couponExclusionCategoryItem}
                                          />
                                        </td>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <SearchableMultiSelectMenu
                                            onSelectItem={(items, meta) => {
                                              const cityId = items.map((i) => i.id);
                                              formHook.setValue("ex_coupon_sub_category", cityId);
                                              updateExplicitSelectAllField("ex_coupon_sub_category", meta);
                                            }}
                                            errorMessages={[{ message: "", type: "required" }]}
                                            fieldError={formHook.formState.errors.ex_coupon_sub_category}
                                            register={formHook.register("ex_coupon_sub_category", {
                                              required: false,
                                            })}
                                            withSelectAll
                                            withDropDownSearch
                                            showTooltips={true}
                                            showTypedErrors={false}
                                            containerClassName=""
                                            placeholder="Select Sub Category"
                                            defaultSelected={couponExclusionSubCategoryItem.filter((c) =>
                                              formHook.watch("ex_coupon_sub_category")?.includes(c.id),
                                            )}
                                            selectItems={couponExclusionSubCategoryItem}
                                          />
                                        </td>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <MultiSelectDropdown
                                            data={productListExclusionItem}
                                            selectedKey="id"
                                            onSelectItem={handleSelectItemEXSKUList}
                                            defaultSelected={defaultSelectedEXSKUList}
                                            required={false}
                                            register={formHook.register}
                                            name="ex_coupon_sku"
                                            error={formHook.formState.errors.ex_coupon_sku as any}
                                            containerClassName="w-full"
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </>
                          )}{" "}
                          <p className="mt-4"></p>
                          {formHook.watch("cart_coupon_applied")?.includes("SERVICE") && (
                            <>
                              <h3 className="text-xs font-bold text-gray-700 uppercase tracking-wider mb-2">
                                SERVICE LEVEL :
                              </h3>
                              <div className="pl-10">
                                <h4 className="text-xs font-bold text-gray-800 uppercase tracking-wide mb-3">
                                  Inclusion
                                </h4>

                                <div className="border border-gray-150 rounded-xl shadow-sm bg-white mb-6">
                                  <table className="min-w-full divide-y divide-gray-100">
                                    <thead>
                                      <tr>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 rounded-tl-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider pl-4"
                                        >
                                          Category
                                        </th>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                        >
                                          Sub Category
                                        </th>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 rounded-tr-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                        >
                                          Sub Service
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-100">
                                      <tr>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <SearchableMultiSelectMenu
                                            onSelectItem={(items, meta) => {
                                              const cityId = items.map((i) => i.id);
                                              formHook.setValue("service_coupon_category", cityId);
                                              formHook.setValue("service_coupon_sub_category", null);
                                              formHook.setValue("service_coupon_sub_service", null);
                                              updateExplicitSelectAllField("service_coupon_category", meta);
                                              updateExplicitSelectAllField("service_coupon_sub_category", {
                                                selectAllUsed: false,
                                              });
                                              updateExplicitSelectAllField("service_coupon_sub_service", {
                                                selectAllUsed: false,
                                              });
                                            }}
                                            errorMessages={[{ message: "", type: "required" }]}
                                            fieldError={formHook.formState.errors.service_coupon_category}
                                            register={formHook.register("service_coupon_category", {
                                              required: itemLabelrequired,
                                            })}
                                            withSelectAll
                                            withDropDownSearch
                                            showTooltips={true}
                                            showTypedErrors={false}
                                            placeholder="Select Category"
                                            defaultSelected={couponCategoryItem.filter((c) =>
                                              formHook.watch("service_coupon_category")?.includes(c.id),
                                            )}
                                            selectItems={couponCategoryItem}
                                          />
                                        </td>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <SearchableMultiSelectMenu
                                            onSelectItem={(items, meta) => {
                                              const cityId = items.map((i) => i.id);
                                              formHook.setValue("service_coupon_sub_category", cityId);
                                              formHook.setValue("service_coupon_sub_service", null);
                                              updateExplicitSelectAllField("service_coupon_sub_category", meta);
                                              updateExplicitSelectAllField("service_coupon_sub_service", {
                                                selectAllUsed: false,
                                              });
                                            }}
                                            errorMessages={[{ message: "", type: "required" }]}
                                            fieldError={formHook.formState.errors.service_coupon_sub_category}
                                            register={formHook.register("service_coupon_sub_category", {
                                              required: itemLabelrequired,
                                            })}
                                            withSelectAll
                                            showTooltips={true}
                                            withDropDownSearch
                                            showTypedErrors={false}
                                            placeholder="Select Sub Category"
                                            defaultSelected={ServicecouponSubCategoryItem.filter((c) =>
                                              formHook.watch("service_coupon_sub_category")?.includes(c.id),
                                            )}
                                            selectItems={ServicecouponSubCategoryItem}
                                          />
                                        </td>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <MultiSelectDropdown
                                            data={subServiceListItem}
                                            selectedKey="id"
                                            onSelectItem={handleSelectItemSubServiceListService}
                                            defaultSelected={defaultSelectedSubServiceListService}
                                            required={itemLabelrequired}
                                            register={formHook.register}
                                            name="service_coupon_sub_service"
                                            error={formHook.formState.errors.service_coupon_sub_service as any}
                                            containerClassName="w-full"
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>

                                <h4 className="text-xs font-bold text-gray-800 uppercase tracking-wide mb-3">
                                  Exclusion
                                </h4>

                                <div className="border border-gray-150 rounded-xl shadow-sm bg-white mb-6">
                                  <table className="min-w-full divide-y divide-gray-100">
                                    <thead>
                                      <tr>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 rounded-tl-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider pl-4"
                                        >
                                          Category
                                        </th>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                        >
                                          Sub Category
                                        </th>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 rounded-tr-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                        >
                                          Sub Service
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-100">
                                      <tr>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <SearchableMultiSelectMenu
                                            onSelectItem={(items, meta) => {
                                              const cityId = items.map((i) => i.id);
                                              formHook.setValue("ex_service_coupon_category", cityId);
                                              updateExplicitSelectAllField("ex_service_coupon_category", meta);
                                            }}
                                            errorMessages={[{ message: "", type: "required" }]}
                                            fieldError={formHook.formState.errors.ex_service_coupon_category}
                                            register={formHook.register("ex_service_coupon_category", {
                                              required: false,
                                            })}
                                            withSelectAll
                                            showTooltips={true}
                                            withDropDownSearch
                                            showTypedErrors={false}
                                            containerClassName=""
                                            placeholder="Select Category"
                                            defaultSelected={couponExclusionCategoryItem.filter((c) =>
                                              formHook.watch("ex_service_coupon_category")?.includes(c.id),
                                            )}
                                            selectItems={couponExclusionCategoryItem}
                                          />
                                        </td>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <SearchableMultiSelectMenu
                                            onSelectItem={(items, meta) => {
                                              const cityId = items.map((i) => i.id);
                                              formHook.setValue("ex_service_coupon_sub_category", cityId);
                                              updateExplicitSelectAllField("ex_service_coupon_sub_category", meta);
                                            }}
                                            errorMessages={[{ message: "", type: "required" }]}
                                            fieldError={formHook.formState.errors.ex_service_coupon_sub_category}
                                            register={formHook.register("ex_service_coupon_sub_category", {
                                              required: false,
                                            })}
                                            withSelectAll
                                            withDropDownSearch
                                            showTooltips={true}
                                            showTypedErrors={false}
                                            containerClassName=""
                                            placeholder="Select Sub Category"
                                            defaultSelected={ServicecouponExclusionSubCategoryItem.filter((c) =>
                                              formHook.watch("ex_service_coupon_sub_category")?.includes(c.id),
                                            )}
                                            selectItems={ServicecouponExclusionSubCategoryItem}
                                          />
                                        </td>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <MultiSelectDropdown
                                            data={subExclusionServiceListItem}
                                            selectedKey="id"
                                            onSelectItem={handleSelectItemEXSubServiceListService}
                                            defaultSelected={defaultSelectedEXSubServiceListService}
                                            required={false}
                                            register={formHook.register}
                                            name="ex_service_coupon_sub_service"
                                            error={formHook.formState.errors.ex_coupon_sub_service as any}
                                            containerClassName="w-full"
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </>
                          )}
                          <p className="mt-4"></p>
                          {formHook.watch("cart_coupon_applied")?.includes("BOM") && (
                            <>
                              <h3 className="text-xs font-bold text-gray-700 uppercase tracking-wider mb-2">
                                BOM LEVEL :
                              </h3>{" "}
                              <div className="pl-10">
                                <h4 className="text-xs font-bold text-gray-800 uppercase tracking-wide mb-3">
                                  Inclusion
                                </h4>
                                <div className="border border-gray-150 rounded-xl shadow-sm bg-white mb-6">
                                  <table className="min-w-full divide-y divide-gray-100">
                                    <thead>
                                      <tr>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 rounded-tl-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider pl-4"
                                        >
                                          Category
                                        </th>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                        >
                                          Sub Category
                                        </th>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 rounded-tr-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                        >
                                          BOM Name
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-100">
                                      <tr>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <SearchableMultiSelectMenu
                                            onSelectItem={(items, meta) => {
                                              const cityId = items.map((i) => i.id);
                                              formHook.setValue("bom_coupon_category", cityId);
                                              updateExplicitSelectAllField("bom_coupon_category", meta);
                                            }}
                                            errorMessages={[{ message: "", type: "required" }]}
                                            fieldError={formHook.formState.errors.bom_coupon_category}
                                            register={formHook.register("bom_coupon_category", {
                                              required: itemLabelrequired,
                                            })}
                                            withSelectAll
                                            showTooltips={true}
                                            showTypedErrors={false}
                                            withDropDownSearch
                                            placeholder="Select Category"
                                            defaultSelected={couponCategoryItem.filter((c) =>
                                              formHook.watch("bom_coupon_category")?.includes(c.id),
                                            )}
                                            selectItems={couponCategoryItem}
                                          />
                                        </td>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <SearchableMultiSelectMenu
                                            onSelectItem={(items, meta) => {
                                              const cityId = items.map((i) => i.id);
                                              formHook.setValue("bom_coupon_sub_category", cityId);
                                              formHook.setValue("bom_coupon_bom_name", null);
                                              updateExplicitSelectAllField("bom_coupon_sub_category", meta);
                                              updateExplicitSelectAllField("bom_coupon_bom_name", {
                                                selectAllUsed: false,
                                              });
                                            }}
                                            errorMessages={[{ message: "", type: "required" }]}
                                            fieldError={formHook.formState.errors.bom_coupon_sub_category}
                                            register={formHook.register("bom_coupon_sub_category", {
                                              required: itemLabelrequired,
                                            })}
                                            withSelectAll
                                            withDropDownSearch
                                            showTooltips={true}
                                            showTypedErrors={false}
                                            placeholder="Select Sub Category"
                                            defaultSelected={BomcouponSubCategoryItem.filter((c) =>
                                              formHook.watch("bom_coupon_sub_category")?.includes(c.id),
                                            )}
                                            selectItems={BomcouponSubCategoryItem}
                                          />
                                        </td>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <SearchableMultiSelectMenu
                                            onSelectItem={(items, meta) => {
                                              const cityId = items.map((i) => i.id);
                                              formHook.setValue("bom_coupon_bom_name", cityId);
                                              updateExplicitSelectAllField("bom_coupon_bom_name", meta);
                                            }}
                                            errorMessages={[{ message: "", type: "required" }]}
                                            fieldError={formHook.formState.errors.bom_coupon_bom_name}
                                            register={formHook.register("bom_coupon_bom_name", {
                                              required: itemLabelrequired,
                                            })}
                                            withSelectAll
                                            withDropDownSearch
                                            showTooltips={true}
                                            showTypedErrors={false}
                                            placeholder="Select Bom"
                                            defaultSelected={bomListItem.filter((c) =>
                                              formHook.watch("bom_coupon_bom_name")?.includes(c.id),
                                            )}
                                            selectItems={bomListItem}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <h4 className="text-xs font-bold text-gray-800 uppercase tracking-wide mb-3">
                                  Exclusion
                                </h4>
                                <div className="border border-gray-150 rounded-xl shadow-sm bg-white mb-6">
                                  <table className="min-w-full divide-y divide-gray-100">
                                    <thead>
                                      <tr>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 rounded-tl-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider pl-4"
                                        >
                                          Category
                                        </th>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                        >
                                          Sub Category
                                        </th>
                                        <th
                                          scope="col"
                                          className="bg-slate-50/75 rounded-tr-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                        >
                                          BOM Name
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-100">
                                      <tr>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <SearchableMultiSelectMenu
                                            onSelectItem={(items, meta) => {
                                              const cityId = items.map((i) => i.id);
                                              formHook.setValue("ex_bom_coupon_category", cityId);
                                              updateExplicitSelectAllField("ex_bom_coupon_category", meta);
                                            }}
                                            errorMessages={[{ message: "", type: "required" }]}
                                            fieldError={formHook.formState.errors.ex_bom_coupon_category}
                                            register={formHook.register("ex_bom_coupon_category", {
                                              required: false,
                                            })}
                                            withDropDownSearch
                                            withSelectAll
                                            showTooltips={true}
                                            showTypedErrors={false}
                                            placeholder="Select Category"
                                            defaultSelected={couponExclusionCategoryItem.filter((c) =>
                                              formHook.watch("ex_bom_coupon_category")?.includes(c.id),
                                            )}
                                            selectItems={couponExclusionCategoryItem}
                                          />
                                        </td>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <SearchableMultiSelectMenu
                                            onSelectItem={(items, meta) => {
                                              const cityId = items.map((i) => i.id);
                                              formHook.setValue("ex_bom_coupon_sub_category", cityId);
                                              updateExplicitSelectAllField("ex_bom_coupon_sub_category", meta);
                                            }}
                                            errorMessages={[{ message: "", type: "required" }]}
                                            fieldError={formHook.formState.errors.ex_bom_coupon_sub_category}
                                            register={formHook.register("ex_bom_coupon_sub_category", {
                                              required: false,
                                            })}
                                            withSelectAll
                                            withDropDownSearch
                                            showTooltips={true}
                                            showTypedErrors={false}
                                            placeholder="Select Sub Category"
                                            defaultSelected={BomcouponExclusionSubCategoryItem.filter((c) =>
                                              formHook.watch("ex_bom_coupon_sub_category")?.includes(c.id),
                                            )}
                                            selectItems={BomcouponExclusionSubCategoryItem}
                                          />
                                        </td>
                                        <td className="p-3 align-middle whitespace-nowrap">
                                          <SearchableMultiSelectMenu
                                            onSelectItem={(items, meta) => {
                                              const cityId = items.map((i) => i.id);
                                              formHook.setValue("ex_bom_coupon_bom_name", cityId);
                                              updateExplicitSelectAllField("ex_bom_coupon_bom_name", meta);
                                            }}
                                            errorMessages={[{ message: "", type: "required" }]}
                                            fieldError={formHook.formState.errors.ex_bom_coupon_bom_name}
                                            register={formHook.register("ex_bom_coupon_bom_name", {
                                              required: false,
                                            })}
                                            withSelectAll
                                            withDropDownSearch
                                            showTooltips={true}
                                            showTypedErrors={false}
                                            placeholder="Select Bom"
                                            defaultSelected={exclusionBomListItem.filter((c) =>
                                              formHook.watch("ex_bom_coupon_bom_name")?.includes(c.id),
                                            )}
                                            selectItems={exclusionBomListItem}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
              </div>
            ) : (
              <div>
                <div>
                  <h2 className="text-sm font-bold text-gray-800 tracking-wide uppercase mb-4">Item Level Discount</h2>
                  <div className="-mx-4 -my-2 sm:-mx-6 lg:-mx-8 py-4">
                    <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                      <div className="ring-opacity-5 sm:rounded-lg">
                        {(couponDetails?.coupon_type === "PRODUCT" || couponDetails?.coupon_type === "QC COUPON") && (
                          <div className="border border-gray-150 rounded-xl shadow-sm bg-white mb-6">
                            <table className="min-w-full divide-y divide-gray-100">
                              <thead>
                                <tr>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 rounded-tl-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider pl-4"
                                  >
                                    Brand
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    Category
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    Sub Category
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 px-4 py-3 whitespace-nowrap text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    <div className="flex justify-around items-center w-full">
                                      <span>SKU</span>
                                      {couponDetails?.coupon_type === "QC COUPON" && (
                                        <div className="flex items-center gap-2">
                                          <button
                                            type="button"
                                            onClick={() => setIsVariantModalOpen(true)}
                                            className="bg-black hover:bg-gray-800 text-white font-semibold text-xs py-1.5 px-3 rounded-md cursor-pointer transition-colors shadow-sm flex items-center gap-1.5"
                                          >
                                            <ArrowUpTrayIcon className="w-3.5 h-3.5" />
                                            <span>Upload</span>
                                          </button>
                                          {uploadedVariants && (
                                            <button
                                              type="button"
                                              onClick={handleClearUpload}
                                              className="flex items-center justify-center w-5 h-5 rounded-xl bg-gray-500 hover:bg-gray-600 text-white cursor-pointer transition-colors"
                                              title="Clear uploaded variants"
                                            >
                                              <XMarkIcon className="w-3 h-3" />
                                            </button>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    Discount/ Flat Price
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 rounded-tr-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    {formHook.watch("discount_price_type")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white divide-y divide-gray-100">
                                <tr>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <div
                                      className={
                                        couponDetails?.coupon_type === "QC COUPON" && uploadedVariants
                                          ? "opacity-50 pointer-events-none"
                                          : ""
                                      }
                                    >
                                      <MultiSelectDropdown
                                        data={brandItemsList}
                                        selectedKey="id"
                                        onSelectItem={handleSelectItemBrandList}
                                        defaultSelected={defaultSelectedBrandList}
                                        required={
                                          itemLabelrequired && !(couponDetails?.coupon_type === "QC COUPON" && !!uploadedVariants)
                                        }
                                        register={formHook.register}
                                        name="coupon_brand"
                                        error={formHook.formState.errors.coupon_brand as any}
                                        placeholder="Select Brands"
                                        containerClassName="w-full"
                                      />
                                    </div>
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <div
                                      className={
                                        couponDetails?.coupon_type === "QC COUPON" && uploadedVariants
                                          ? "opacity-50 pointer-events-none"
                                          : ""
                                      }
                                    >
                                      <MultiSelectDropdown
                                        data={couponCategoryItem}
                                        selectedKey="id"
                                        onSelectItem={handleSelectItemCategoryList}
                                        defaultSelected={defaultSelectedCategoryList}
                                        required={
                                          itemLabelrequired && !(couponDetails?.coupon_type === "QC COUPON" && !!uploadedVariants)
                                        }
                                        register={formHook.register}
                                        name="coupon_category"
                                        error={formHook.formState.errors.coupon_category as any}
                                        placeholder="Select Category"
                                        containerClassName="w-full"
                                      />
                                    </div>
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <div
                                      className={
                                        couponDetails?.coupon_type === "QC COUPON" && uploadedVariants
                                          ? "opacity-50 pointer-events-none"
                                          : ""
                                      }
                                    >
                                      <MultiSelectDropdown
                                        key={subCategoryDropdownKey}
                                        data={couponSubCategoryItem}
                                        selectedKey="id"
                                        onSelectItem={handleSelectItemSubCategoryList}
                                        defaultSelected={defaultSelectedSubCategoryList}
                                        required={
                                          itemLabelrequired && !(couponDetails?.coupon_type === "QC COUPON" && !!uploadedVariants)
                                        }
                                        register={formHook.register}
                                        name="coupon_sub_category"
                                        error={formHook.formState.errors.coupon_sub_category as any}
                                        placeholder="Select Sub Category"
                                        containerClassName="w-full"
                                      />
                                    </div>
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    {couponDetails?.coupon_type === "QC COUPON" && uploadedSkuItems ? (
                                      <SearchableMultiSelectMenu
                                        onSelectItem={(items, meta) => {
                                          const ids = items.map((i) => i.id);
                                          updateExplicitSelectAllField("coupon_sku", meta);
                                          formHook.setValue("coupon_sku", ids);
                                        }}
                                        errorMessages={[{ message: "", type: "required" }]}
                                        fieldError={formHook.formState.errors.coupon_sku}
                                        register={formHook.register("coupon_sku", { required: false })}
                                        withSelectAll
                                        withDropDownSearch
                                        showTooltips={true}
                                        showTypedErrors={false}
                                        placeholder="Select SKU"
                                        defaultSelected={uploadedSkuItems}
                                        defaultSelectedIds={uploadedSkuItems.map((v) => v.id)}
                                        selectItems={uploadedSkuItems}
                                      />
                                    ) : (
                                      <MultiSelectDropdown
                                        data={productListItem}
                                        selectedKey="id"
                                        onSelectItem={handleSelectItemSKUList}
                                        defaultSelected={defaultSelectedSKUList}
                                        required={couponDetails?.coupon_type !== "QC COUPON" && itemLabelrequired}
                                        register={formHook.register}
                                        name="coupon_sku"
                                        error={formHook.formState.errors.coupon_sku as any}
                                        containerClassName="w-full"
                                      />
                                    )}
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <div className="flex">
                                      {is_exhaustible_coupon ? (
                                        <p className="text-xs text-black font-medium">percentage</p>
                                      ) : (
                                        <div
                                          className={
                                            couponDetails?.coupon_type === "QC COUPON"
                                              ? "opacity-50 pointer-events-none w-full"
                                              : "w-full"
                                          }
                                        >
                                          <SearchableSelectMenu
                                            errorMessages={[{ message: "", type: "required" }]}
                                            onSelectItem={(item) => {
                                              if (item) {
                                                formHook.setValue("discount_price_type", item.id);
                                              }
                                            }}
                                            fieldError={formHook.formState.errors.discount_price_type}
                                            register={formHook.register("discount_price_type", {
                                              required: itemLabelrequired,
                                            })}
                                            selectItems={couponTypeItems}
                                            placeholder="Select"
                                            showTooltips={true}
                                            showTypedErrors={true}
                                            showDropdownIcon={true}
                                            defaultSelected={
                                              couponTypeItems?.filter(
                                                (oc) => oc.id === formHook.watch("discount_price_type"),
                                              )[0]
                                            }
                                            listBoxClassName="w-36"
                                            className="text-gray-800 col-span-1"
                                            containerClassName="w-full"
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    {is_exhaustible_coupon ? (
                                      <p className="text-xs text-black font-medium">100</p>
                                    ) : (
                                      <Input
                                        className="text-xs w-full max-w-[120px]"
                                        placeholder="Enter Value"
                                        register={formHook.register("discount_value", {
                                          required: itemLabelrequired,
                                          ...(formHook.watch("discount_price_type") === "PERCENTAGE" && { max: 100 }),
                                          ...(forOnlyPercentageAndNumberRegex.validations as any),
                                        })}
                                        fieldError={formHook.formState.errors.discount_value}
                                        errorMessages={[
                                          { message: "", type: "required" },
                                          forOnlyPercentageAndNumberRegex.errors,
                                          ...(formHook.watch("discount_price_type") === "PERCENTAGE" ? [{ message: "Maximum value allowed is 100", type: "max" }] : []),
                                        ]}
                                      />
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )}
                        {couponDetails?.coupon_type === "SERVICE" && (
                          <div className="border border-gray-150 rounded-xl shadow-sm bg-white mb-6">
                            <table className="min-w-full divide-y divide-gray-100">
                              <thead>
                                <tr>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 rounded-tl-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider pl-4"
                                  >
                                    Category
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    Sub Category
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    Sub Service
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    Discount/ Flat Price
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 rounded-tr-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    {formHook.watch("discount_price_type")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white divide-y divide-gray-100">
                                <tr>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <MultiSelectDropdown
                                      data={couponCategoryItem}
                                      selectedKey="id"
                                      onSelectItem={handleSelectItemCategoryList}
                                      defaultSelected={defaultSelectedCategoryList}
                                      required={itemLabelrequired}
                                      register={formHook.register}
                                      name="coupon_category"
                                      error={formHook.formState.errors.coupon_category as any}
                                      placeholder="Select Category"
                                      containerClassName="w-full"
                                    />
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <MultiSelectDropdown
                                      key={subCategoryDropdownKey}
                                      data={couponSubCategoryItem}
                                      selectedKey="id"
                                      onSelectItem={handleSelectItemSubCategoryList}
                                      defaultSelected={defaultSelectedSubCategoryList}
                                      required={itemLabelrequired}
                                      register={formHook.register}
                                      name="coupon_sub_category"
                                      error={formHook.formState.errors.coupon_sub_category as any}
                                      placeholder="Select Sub Category"
                                      containerClassName="w-full"
                                    />
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <MultiSelectDropdown
                                      data={subServiceListItem}
                                      selectedKey="id"
                                      onSelectItem={handleSelectItemSubServiceList}
                                      defaultSelected={defaultSelectedSubServiceList}
                                      required={itemLabelrequired}
                                      register={formHook.register}
                                      name="coupon_sub_service"
                                      error={formHook.formState.errors.coupon_sub_service as any}
                                      containerClassName="w-full"
                                    />
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <div className="flex">
                                      {is_exhaustible_coupon ? (
                                        <p className="text-xs text-black font-medium">percentage</p>
                                      ) : (
                                        <SearchableSelectMenu
                                          errorMessages={[{ message: "", type: "required" }]}
                                          onSelectItem={(item) => {
                                            if (item) {
                                              formHook.setValue("discount_price_type", item.id);
                                            }
                                          }}
                                          fieldError={formHook.formState.errors.discount_price_type}
                                          register={formHook.register("discount_price_type", {
                                            required: itemLabelrequired,
                                          })}
                                          selectItems={couponTypeItems}
                                          placeholder="Select"
                                          showTooltips={true}
                                          showTypedErrors={true}
                                          showDropdownIcon={true}
                                          defaultSelected={
                                            couponTypeItems?.filter(
                                              (oc) => oc.id === formHook.watch("discount_price_type"),
                                            )[0]
                                          }
                                          listBoxClassName="w-36"
                                          className="text-gray-800 col-span-1"
                                          containerClassName="w-full"
                                        />
                                      )}
                                    </div>
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    {is_exhaustible_coupon ? (
                                      <p className="text-xs text-black font-medium">100</p>
                                    ) : (
                                      <Input
                                        className="text-xs w-full max-w-[120px]"
                                        placeholder="Enter Value"
                                        register={formHook.register("discount_value", {
                                          required: itemLabelrequired,
                                          ...(formHook.watch("discount_price_type") === "PERCENTAGE" && { max: 100 }),
                                          ...(forOnlyPercentageAndNumberRegex.validations as any),
                                        })}
                                        fieldError={formHook.formState.errors.discount_value}
                                        errorMessages={[
                                          { message: "", type: "required" },
                                          forOnlyPercentageAndNumberRegex.errors,
                                          ...(formHook.watch("discount_price_type") === "PERCENTAGE" ? [{ message: "Maximum value allowed is 100", type: "max" }] : []),
                                        ]}
                                      />
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )}
                        {couponDetails?.coupon_type === "BOM" && (
                          <div className="border border-gray-150 rounded-xl shadow-sm bg-white mb-6">
                            <table className="min-w-full divide-y divide-gray-100">
                              <thead>
                                <tr>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 rounded-tl-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider pl-4"
                                  >
                                    Category
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    Sub Category
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    BOM Name
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    Discount/ Flat Price
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 rounded-tr-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    {formHook.watch("discount_price_type")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white divide-y divide-gray-100">
                                <tr>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <MultiSelectDropdown
                                      data={couponCategoryItem}
                                      selectedKey="id"
                                      onSelectItem={handleSelectItemCategoryList}
                                      defaultSelected={defaultSelectedCategoryList}
                                      required={itemLabelrequired}
                                      register={formHook.register}
                                      name="coupon_category"
                                      error={formHook.formState.errors.coupon_category as any}
                                      placeholder="Select Category"
                                      containerClassName="w-full"
                                    />
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <MultiSelectDropdown
                                      key={subCategoryDropdownKey}
                                      data={couponSubCategoryItem}
                                      selectedKey="id"
                                      onSelectItem={handleSelectItemSubCategoryList}
                                      defaultSelected={defaultSelectedSubCategoryList}
                                      required={itemLabelrequired}
                                      register={formHook.register}
                                      name="coupon_sub_category"
                                      error={formHook.formState.errors.coupon_sub_category as any}
                                      placeholder="Select Sub Category"
                                      containerClassName="w-full"
                                    />
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <SearchableMultiSelectMenu
                                      onSelectItem={(items, meta) => {
                                        const cityId = items.map((i) => i.id);
                                        formHook.setValue("coupon_bom_name", cityId);
                                        updateExplicitSelectAllField("coupon_bom_name", meta);
                                      }}
                                      errorMessages={[{ message: "", type: "required" }]}
                                      fieldError={formHook.formState.errors.coupon_bom_name}
                                      register={formHook.register("coupon_bom_name", {
                                        required: itemLabelrequired,
                                      })}
                                      withSelectAll
                                      withDropDownSearch
                                      showTooltips={true}
                                      showTypedErrors={false}
                                      placeholder="Select Bom"
                                      defaultSelected={bomListItem.filter((c) =>
                                        formHook.watch("coupon_bom_name")?.includes(c.id),
                                      )}
                                      selectItems={bomListItem}
                                    />
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <div className="flex">
                                      {is_exhaustible_coupon ? (
                                        <p className="text-xs text-black font-medium">percentage</p>
                                      ) : (
                                        <SearchableSelectMenu
                                          errorMessages={[{ message: "", type: "required" }]}
                                          onSelectItem={(item) => {
                                            if (item) {
                                              formHook.setValue("discount_price_type", item.id);
                                            }
                                          }}
                                          fieldError={formHook.formState.errors.discount_price_type}
                                          register={formHook.register("discount_price_type", {
                                            required: itemLabelrequired,
                                          })}
                                          selectItems={couponTypeItems}
                                          placeholder="Select"
                                          showTooltips={true}
                                          showTypedErrors={true}
                                          showDropdownIcon={true}
                                          defaultSelected={
                                            couponTypeItems?.filter(
                                              (oc) => oc.id === formHook.watch("discount_price_type"),
                                            )[0]
                                          }
                                          listBoxClassName="w-36"
                                          className="text-gray-800 col-span-1"
                                          containerClassName="w-full"
                                        />
                                      )}
                                    </div>
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    {is_exhaustible_coupon ? (
                                      <p className="text-xs text-black font-medium">100</p>
                                    ) : (
                                      <Input
                                        className="text-xs w-full max-w-[120px]"
                                        placeholder="Enter Value"
                                        register={formHook.register("discount_value", {
                                          required: itemLabelrequired,
                                          ...(formHook.watch("discount_price_type") === "PERCENTAGE" && { max: 100 }),
                                          ...(forOnlyPercentageAndNumberRegex.validations as any),
                                        })}
                                        fieldError={formHook.formState.errors.discount_value}
                                        errorMessages={[
                                          { message: "", type: "required" },
                                          forOnlyPercentageAndNumberRegex.errors,
                                          ...(formHook.watch("discount_price_type") === "PERCENTAGE" ? [{ message: "Maximum value allowed is 100", type: "max" }] : []),
                                        ]}
                                      />
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )}{" "}
                        {couponDetails?.coupon_type === "DISCOUNT ON MEMBERSHIP" && (
                          <div className="border border-gray-150 rounded-xl shadow-sm bg-white mb-6">
                            <table className="min-w-full divide-y divide-gray-100">
                              <thead>
                                <tr>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 rounded-tl-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider pl-4"
                                  >
                                    Membership
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    Discount/ Flat Price
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 rounded-tr-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    {formHook.watch("discount_price_type")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white divide-y divide-gray-100">
                                <tr>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <SearchableMultiSelectMenu
                                      onSelectItem={(items, meta) => {
                                        const cityId = items.map((i) => i.id);
                                        formHook.setValue("coupon_membership", cityId);
                                        updateExplicitSelectAllField("coupon_membership", meta);
                                      }}
                                      errorMessages={[{ message: "", type: "required" }]}
                                      fieldError={formHook.formState.errors.coupon_category}
                                      register={formHook.register("coupon_membership", {
                                        required: itemLabelrequired,
                                      })}
                                      withSelectAll
                                      showTooltips={true}
                                      showTypedErrors={false}
                                      withDropDownSearch
                                      containerClassName="w-full"
                                      placeholder="Select Membership"
                                      defaultSelected={membershipListItem.filter((c) =>
                                        formHook.watch("coupon_membership")?.includes(c.id),
                                      )}
                                      selectItems={membershipListItem}
                                    />
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <div className="flex">
                                      {is_exhaustible_coupon ? (
                                        <p className="text-xs text-black font-medium">percentage</p>
                                      ) : (
                                        <SearchableSelectMenu
                                          errorMessages={[{ message: "", type: "required" }]}
                                          onSelectItem={(item) => {
                                            if (item) {
                                              formHook.setValue("discount_price_type", item.id);
                                            }
                                          }}
                                          fieldError={formHook.formState.errors.discount_price_type}
                                          register={formHook.register("discount_price_type", {
                                            required: itemLabelrequired,
                                          })}
                                          selectItems={couponTypeItems}
                                          placeholder="Select"
                                          showTooltips={true}
                                          showTypedErrors={true}
                                          showDropdownIcon={true}
                                          defaultSelected={
                                            couponTypeItems?.filter(
                                              (oc) => oc.id === formHook.watch("discount_price_type"),
                                            )[0]
                                          }
                                          listBoxClassName="w-36"
                                          className="text-gray-800 col-span-1"
                                          containerClassName="w-full"
                                        />
                                      )}
                                    </div>
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    {is_exhaustible_coupon ? (
                                      <p className="text-xs text-black font-medium">100</p>
                                    ) : (
                                      <Input
                                        className="text-xs w-full max-w-[120px]"
                                        placeholder="Enter Value"
                                        register={formHook.register("discount_value", {
                                          required: itemLabelrequired,
                                          ...(formHook.watch("discount_price_type") === "PERCENTAGE" && { max: 100 }),
                                          ...(forOnlyPercentageAndNumberRegex.validations as any),
                                        })}
                                        fieldError={formHook.formState.errors.discount_value}
                                        errorMessages={[
                                          { message: "", type: "required" },
                                          forOnlyPercentageAndNumberRegex.errors,
                                          ...(formHook.watch("discount_price_type") === "PERCENTAGE" ? [{ message: "Maximum value allowed is 100", type: "max" }] : []),
                                        ]}
                                      />
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <h2 className="text-sm font-bold text-gray-800 tracking-wide uppercase mb-4">Exclusion</h2>
                  <div className="-mx-4 -my-2 sm:-mx-6 lg:-mx-8 py-4">
                    <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                      <div className="ring-opacity-5 sm:rounded-lg">
                        {(couponDetails?.coupon_type === "PRODUCT" || couponDetails?.coupon_type === "QC COUPON") && (
                          <div className="border border-gray-150 rounded-xl shadow-sm bg-white mb-6">
                            <table className="min-w-full divide-y divide-gray-100">
                              <thead>
                                <tr>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 rounded-tl-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider pl-4"
                                  >
                                    Brand
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    Category
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    Sub Category
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 rounded-tr-xl px-4 py-3 whitespace-nowrap text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    <div className="flex justify-around items-center w-full">
                                      <span>SKU</span>
                                      {couponDetails?.coupon_type === "QC COUPON" && (
                                        <div className="flex items-center gap-2">
                                          <button
                                            type="button"
                                            onClick={() => setIsVariantModalExclusionOpen(true)}
                                            className="bg-black hover:bg-gray-800 text-white font-semibold text-xs py-1.5 px-3 rounded-md cursor-pointer transition-colors shadow-sm flex items-center gap-1.5"
                                          >
                                            <ArrowUpTrayIcon className="w-3.5 h-3.5" />
                                            <span>Upload</span>
                                          </button>
                                          {uploadedVariantsExclusion && (
                                            <button
                                              type="button"
                                              onClick={handleClearExclusionUpload}
                                              className="flex items-center justify-center w-5 h-5 rounded-xl bg-gray-500 hover:bg-gray-600 text-white cursor-pointer transition-colors"
                                              title="Clear uploaded variants"
                                            >
                                              <XMarkIcon className="w-3 h-3" />
                                            </button>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white divide-y divide-gray-100">
                                <tr>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <div
                                      className={
                                        couponDetails?.coupon_type === "QC COUPON" && uploadedVariantsExclusion
                                          ? "opacity-50 pointer-events-none"
                                          : ""
                                      }
                                    >
                                      <MultiSelectDropdown
                                        data={brandItemsList}
                                        selectedKey="id"
                                        onSelectItem={handleSelectItemEXBrandList}
                                        defaultSelected={defaultSelectedEXBrandList}
                                        required={false}
                                        register={formHook.register}
                                        name="ex_coupon_brand"
                                        error={formHook.formState.errors.ex_coupon_brand as any}
                                        placeholder="Select Brands"
                                        containerClassName="w-full"
                                      />
                                    </div>
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <div
                                      className={
                                        couponDetails?.coupon_type === "QC COUPON" && uploadedVariantsExclusion
                                          ? "opacity-50 pointer-events-none"
                                          : ""
                                      }
                                    >
                                      <MultiSelectDropdown
                                        data={couponExclusionCategoryItem}
                                        selectedKey="id"
                                        onSelectItem={handleSelectItemEXCategoryList}
                                        defaultSelected={defaultSelectedEXCategoryList}
                                        required={false}
                                        register={formHook.register}
                                        name="ex_coupon_category"
                                        error={formHook.formState.errors.ex_coupon_category as any}
                                        placeholder="Select Category"
                                        containerClassName="w-full"
                                      />
                                    </div>
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <div
                                      className={
                                        couponDetails?.coupon_type === "QC COUPON" && uploadedVariantsExclusion
                                          ? "opacity-50 pointer-events-none"
                                          : ""
                                      }
                                    >
                                      <MultiSelectDropdown
                                        key={exSubCategoryDropdownKey}
                                        data={couponExclusionSubCategoryItem}
                                        selectedKey="id"
                                        onSelectItem={handleSelectItemEXSubCategoryList}
                                        defaultSelected={defaultSelectedEXSubCategoryList}
                                        required={false}
                                        register={formHook.register}
                                        name="ex_coupon_sub_category"
                                        error={formHook.formState.errors.ex_coupon_sub_category as any}
                                        placeholder="Select Sub Category"
                                        containerClassName="w-full"
                                      />
                                    </div>
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    {couponDetails?.coupon_type === "QC COUPON" && uploadedSkuItemsExclusion ? (
                                      <SearchableMultiSelectMenu
                                        onSelectItem={(items, meta) => {
                                          const ids = items.map((i) => i.id);
                                          updateExplicitSelectAllField("ex_coupon_sku", meta);
                                          formHook.setValue("ex_coupon_sku", ids);
                                        }}
                                        errorMessages={[{ message: "", type: "required" }]}
                                        fieldError={formHook.formState.errors.ex_coupon_sku}
                                        register={formHook.register("ex_coupon_sku", { required: false })}
                                        withSelectAll
                                        withDropDownSearch
                                        showTooltips={true}
                                        showTypedErrors={false}
                                        placeholder="Select SKU"
                                        defaultSelected={uploadedSkuItemsExclusion}
                                        defaultSelectedIds={uploadedSkuItemsExclusion.map((v) => v.id)}
                                        selectItems={uploadedSkuItemsExclusion}
                                      />
                                    ) : (
                                      <MultiSelectDropdown
                                        data={productListExclusionItem}
                                        selectedKey="id"
                                        onSelectItem={handleSelectItemEXSKUList}
                                        defaultSelected={defaultSelectedEXSKUList}
                                        required={false}
                                        register={formHook.register}
                                        name="ex_coupon_sku"
                                        error={formHook.formState.errors.ex_coupon_sku as any}
                                        containerClassName="w-full"
                                      />
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )}
                        {couponDetails?.coupon_type === "SERVICE" && (
                          <div className="border border-gray-150 rounded-xl shadow-sm bg-white mb-6">
                            <table className="min-w-full divide-y divide-gray-100">
                              <thead>
                                <tr>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 rounded-tl-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider pl-4"
                                  >
                                    Category
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    Sub Category
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 rounded-tr-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    Sub Service
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white divide-y divide-gray-100">
                                <tr>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <MultiSelectDropdown
                                      data={couponExclusionCategoryItem}
                                      selectedKey="id"
                                      onSelectItem={handleSelectItemEXCategoryList}
                                      defaultSelected={defaultSelectedEXCategoryList}
                                      required={false}
                                      register={formHook.register}
                                      name="ex_coupon_category"
                                      error={formHook.formState.errors.ex_coupon_category as any}
                                      placeholder="Select Category"
                                      containerClassName="w-full"
                                    />
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <MultiSelectDropdown
                                      key={exSubCategoryDropdownKey}
                                      data={couponExclusionSubCategoryItem}
                                      selectedKey="id"
                                      onSelectItem={handleSelectItemEXSubCategoryList}
                                      defaultSelected={defaultSelectedEXSubCategoryList}
                                      required={false}
                                      register={formHook.register}
                                      name="ex_coupon_sub_category"
                                      error={formHook.formState.errors.ex_coupon_sub_category as any}
                                      placeholder="Select Sub Category"
                                      containerClassName="w-full"
                                    />
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <MultiSelectDropdown
                                      data={subExclusionServiceListItem}
                                      selectedKey="id"
                                      onSelectItem={handleSelectItemEXSubServiceList}
                                      defaultSelected={defaultSelectedEXSubServiceList}
                                      required={false}
                                      register={formHook.register}
                                      name="ex_coupon_sub_service"
                                      error={formHook.formState.errors.ex_coupon_sub_service as any}
                                      containerClassName="w-full"
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )}
                        {couponDetails?.coupon_type === "BOM" && (
                          <div className="border border-gray-150 rounded-xl shadow-sm bg-white mb-6">
                            <table className="min-w-full divide-y divide-gray-100">
                              <thead>
                                <tr>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 rounded-tl-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider pl-4"
                                  >
                                    Category
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    Sub Category
                                  </th>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 rounded-tr-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider"
                                  >
                                    BOM Name
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white divide-y divide-gray-100">
                                <tr>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <MultiSelectDropdown
                                      data={couponExclusionCategoryItem}
                                      selectedKey="id"
                                      onSelectItem={handleSelectItemEXCategoryList}
                                      defaultSelected={defaultSelectedEXCategoryList}
                                      required={false}
                                      register={formHook.register}
                                      name="ex_coupon_category"
                                      error={formHook.formState.errors.ex_coupon_category as any}
                                      placeholder="Select Category"
                                      containerClassName="w-full"
                                    />
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <MultiSelectDropdown
                                      key={exSubCategoryDropdownKey}
                                      data={couponExclusionSubCategoryItem}
                                      selectedKey="id"
                                      onSelectItem={handleSelectItemEXSubCategoryList}
                                      defaultSelected={defaultSelectedEXSubCategoryList}
                                      required={false}
                                      register={formHook.register}
                                      name="ex_coupon_sub_category"
                                      error={formHook.formState.errors.ex_coupon_sub_category as any}
                                      placeholder="Select Sub Category"
                                      containerClassName="w-full"
                                    />
                                  </td>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <MultiSelectDropdown
                                      data={exclusionBomListItem}
                                      selectedKey="id"
                                      onSelectItem={handleSelectItemEXBomList}
                                      defaultSelected={defaultSelectedEXBomList}
                                      required={false}
                                      register={formHook.register}
                                      name="ex_coupon_bom_name"
                                      error={formHook.formState.errors.ex_coupon_bom_name as any}
                                      placeholder="Select Bom"
                                      containerClassName="w-full"
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )}
                        {couponDetails?.coupon_type === "DISCOUNT ON MEMBERSHIP" && (
                          <div className="border border-gray-150 rounded-xl shadow-sm bg-white mb-6">
                            <table className="min-w-full divide-y divide-gray-100">
                              <thead>
                                <tr>
                                  <th
                                    scope="col"
                                    className="bg-slate-50/75 rounded-t-xl px-4 py-3 text-left text-[10px] font-bold text-gray-500 uppercase tracking-wider pl-4"
                                  >
                                    Membership
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white divide-y divide-gray-100">
                                <tr>
                                  <td className="p-3 align-middle whitespace-nowrap">
                                    <SearchableMultiSelectMenu
                                      onSelectItem={(items, meta) => {
                                        const cityId = items.map((i) => i.id);
                                        formHook.setValue("ex_coupon_membership", cityId);
                                        updateExplicitSelectAllField("ex_coupon_membership", meta);
                                      }}
                                      errorMessages={[{ message: "", type: "required" }]}
                                      fieldError={formHook.formState.errors.ex_coupon_category}
                                      register={formHook.register("ex_coupon_membership", {
                                        required: false,
                                      })}
                                      withDropDownSearch
                                      withSelectAll
                                      showTooltips={true}
                                      showTypedErrors={false}
                                      containerClassName="w-96"
                                      placeholder="Select Membership"
                                      defaultSelected={membershipListItemExclusion.filter((c) =>
                                        formHook.watch("ex_coupon_membership")?.includes(c.id),
                                      )}
                                      selectItems={membershipListItemExclusion}
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        )}
                        <p className="py-3"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="right-0 bottom-0 fixed flex justify-end items-center gap-4 border-t border-gray-200 w-full px-6 py-4 bg-white shadow-[0_-4px_10px_rgba(0,0,0,0.04)] z-10">
            <button
              type="button"
              onClick={() => handelBackStepper()}
              className="text-xs px-5 py-2.5 rounded-lg bg-[#b1b5bb] font-semibold text-white hover:bg-[#979ba1] transition-colors shadow-sm"
            >
              Back
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="text-xs px-5 py-2.5 rounded-lg bg-[#193A6A] font-semibold text-white hover:bg-[#122b50] disabled:opacity-50 disabled:cursor-not-allowed transition-colors shadow-sm flex items-center justify-center gap-2"
            >
              {isSubmitting && (
                <svg
                  className="animate-spin h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                </svg>
              )}
              {isSubmitting ? "Saving..." : "Save & Next"}
            </button>
          </div>
        </form>
      </div>
      <VariantUploadModal
        open={isVariantModalOpen}
        onClose={() => setIsVariantModalOpen(false)}
        onSuccess={(variants) => {
          setPreUploadSKUList(formHook.getValues("coupon_sku") || []);
          formHook.unregister("coupon_sku", { keepValue: true });
          setUploadedVariants(variants);
          formHook.setValue(
            "coupon_sku",
            variants.map((v) => v.vetic_variant_id),
          );
        }}
      />
      <VariantUploadModal
        open={isVariantModalExclusionOpen}
        onClose={() => setIsVariantModalExclusionOpen(false)}
        onSuccess={(variants) => {
          setPreUploadSKUListExclusion(formHook.getValues("ex_coupon_sku") || []);
          setUploadedVariantsExclusion(variants);
          formHook.setValue(
            "ex_coupon_sku",
            variants.map((v) => v.vetic_variant_id),
          );
        }}
      />
    </div>
  );
};
export default CouponDiscountComponent;
